import { ɵɵdefineInjectable, ɵsetClassMetadata, Injectable, ɵɵdefineComponent, ɵɵelementStart, ɵɵtext, ɵɵelementEnd, Component, ɵɵinject, Inject, ɵɵdirectiveInject, ɵɵelement, ɵɵlistener, ɵɵadvance, ɵɵtextInterpolate, ɵɵproperty, ɵɵtextInterpolate1, Input, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule, ɵɵpipe, ɵɵpipeBind2, ɵɵgetCurrentView, ɵɵrestoreView, ɵɵnextContext, ɵɵtemplate, ɵɵpureFunction0, ɵɵpureFunction1, ɵɵelementContainerStart, ɵɵelementContainerEnd, EventEmitter, ɵɵNgOnChangesFeature, Output, ɵɵreference, ɵɵpropertyInterpolate, ɵɵsanitizeHtml, ɵɵviewQuery, ɵɵqueryRefresh, ɵɵloadQuery, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, ɵangular_packages_forms_forms_y, NgControlStatusGroup, FormGroupDirective, DefaultValueAccessor, NgControlStatus, FormControlName, NgModel, NgForm, RequiredValidator, EmailValidator, MinLengthValidator, PatternValidator, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpParams, HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Subject, Observable, throwError } from 'rxjs';
import { switchMap, tap, catchError, finalize } from 'rxjs/operators';
import { Router, RouterLinkWithHref, RouterLinkActive, ActivatedRoute, RouterModule } from '@angular/router';
import { MatCard, MatCardTitle, MatCardContent, MatCardModule, MatCardSubtitle, MatCardHeader, MatCardAvatar } from '@angular/material/card';
import { MatFormField, MatLabel, MatFormFieldModule, MatError } from '@angular/material/form-field';
import { MatInput, MatInputModule } from '@angular/material/input';
import { MatButton, MatButtonModule, MatAnchor } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { registerLocaleData, NgIf, DatePipe, NgForOf, NgStyle, CommonModule } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule, MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatCellDef, MatHeaderRowDef, MatRowDef, MatHeaderCell, MatCell, MatHeaderRow, MatRow } from '@angular/material/table';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule, MatIcon } from '@angular/material/icon';
import { MatCheckboxModule, MatCheckbox } from '@angular/material/checkbox';
import { MatSelectModule, MatSelect } from '@angular/material/select';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule, MatList, MatListItem, MatSelectionList, MatListOption } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import localeIt from '@angular/common/locales/it';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule, MatPaginator } from '@angular/material/paginator';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule, MatOption } from '@angular/material/core';

class DstSecurityService {
    constructor() { }
}
DstSecurityService.ɵfac = function DstSecurityService_Factory(t) { return new (t || DstSecurityService)(); };
DstSecurityService.ɵprov = ɵɵdefineInjectable({ token: DstSecurityService, factory: DstSecurityService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DstSecurityService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class DstSecurityComponent {
    constructor() { }
    ngOnInit() {
    }
}
DstSecurityComponent.ɵfac = function DstSecurityComponent_Factory(t) { return new (t || DstSecurityComponent)(); };
DstSecurityComponent.ɵcmp = ɵɵdefineComponent({ type: DstSecurityComponent, selectors: [["dst-sec-dst-security"]], decls: 2, vars: 0, template: function DstSecurityComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "p");
        ɵɵtext(1, " dst-security works! ");
        ɵɵelementEnd();
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DstSecurityComponent, [{
        type: Component,
        args: [{
                selector: 'dst-sec-dst-security',
                template: `
    <p>
      dst-security works!
    </p>
  `,
                styles: []
            }]
    }], function () { return []; }, null); })();

class UtilsService {
    constructor(env) {
        this.env = env;
    }
    getEndPoint(uri) {
        if (this.env.SECURITY_END_POINT == null) {
            throw new Error("you must set SECURITY_END_POINT");
        }
        return uri == null ? this.env.SECURITY_END_POINT : this.env.SECURITY_END_POINT + "/" + uri;
    }
    getEnvProperty(property) {
        return this.env[property];
    }
    static getPageQueryParam(page) {
        page = page ? page : { number: 0, size: 5, totalElements: 0, totalPages: 0 };
        page.number = page.number ? page.number : 0;
        page.size = page.size ? page.size : 5;
        return `page=${page.number}&size=${page.size}`;
    }
    static fillPageObj(pageEvent, page) {
        console.debug(pageEvent);
        if (page.size != pageEvent.pageSize) {
            page.size = pageEvent.pageSize;
            page.number = 0;
        }
        else {
            page.number = pageEvent.pageIndex;
        }
    }
}
UtilsService.ɵfac = function UtilsService_Factory(t) { return new (t || UtilsService)(ɵɵinject('environment')); };
UtilsService.ɵprov = ɵɵdefineInjectable({ token: UtilsService, factory: UtilsService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(UtilsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: ['environment']
            }] }]; }, null); })();

class Constants {
}
Constants.AUTH_TOKEN_KEY = "x-auth-token";
Constants.USER_KEY = "user";
Constants.DEFAULT_PASSWORD_REGEX = "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@$!%*?&])[A-Za-z0-9@$!%*?&]{8,}$";

class HateoasService {
    constructor(http) {
        this.http = http;
    }
    get(url) {
        return this.http.get(url);
    }
    createObject(url, body) {
        return this.http.post(url, body);
    }
    // updateObject<T>(url?: string, body: T | any) {
    //   return this.http.put<T>(url, body);
    // }
    patchObject(url, body) {
        return this.http.patch(url, body);
    }
    // getObject(url: string) {
    //   return this.http.get<any>(url);
    // }
    // createObject(url,body){
    //   return this.http.post<any>(url, body);
    // }
    updateObject(body) {
        return this.http.put(body._links.self.href, body);
    }
    linkObject(url, link) {
        let cleanUrl = url.replace(/{\?projection}/, '');
        console.debug(cleanUrl);
        return this.http.put(cleanUrl, "\n" + link + "\n", { headers: { 'Content-Type': 'text/uri-list' } });
    }
    addElementToCollection(url, link) {
        let cleanUrl = url.replace(/{\?projection}/, '');
        return this.http.post(cleanUrl, "\n" + link + "\n", { headers: { 'Content-Type': 'text/uri-list' } });
    }
    removeElementFromCollection(url) {
        let cleanUrl = url.replace(/{\?projection}/, '');
        return this.http.delete(cleanUrl, { headers: { 'Content-Type': 'text/uri-list' } });
    }
    deleteObject(url) {
        return this.http.delete(url);
    }
    static getLinkRequestOption() {
        const requestOptions = {
            params: new HttpParams()
        };
        requestOptions.params.set('Content-Type', 'text/uri-list');
        return requestOptions;
    }
}
HateoasService.ɵfac = function HateoasService_Factory(t) { return new (t || HateoasService)(ɵɵinject(HttpClient)); };
HateoasService.ɵprov = ɵɵdefineInjectable({ token: HateoasService, factory: HateoasService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(HateoasService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HttpClient }]; }, null); })();

class PrincipalService {
    constructor(http, utils, hateoasService) {
        this.http = http;
        this.utils = utils;
        this.hateoasService = hateoasService;
        this.authenticated = new Subject();
        this.authenticatedOb = this.authenticated.asObservable();
        this.logged = false;
    }
    getMyPrincipal() {
        return this.http.get(this.utils.getEndPoint(PrincipalService.baseServiceUri + "/search/myPrincipal"));
    }
    login(email, password) {
        let princ = null;
        return this.loginWithBasic(email, password).pipe(switchMap(result => {
            princ = result;
            let link = princ._links.profile.href.replace('{?projection}', '?projection=principalProfile');
            let headers = new HttpHeaders().set("Authorization", "Basic " + btoa(email + ":" + password));
            return this.hateoasService.get(link);
        }), switchMap(result => {
            princ.profile = result;
            return this.setLogged(princ);
        }));
    }
    logout() {
        localStorage.removeItem(Constants.AUTH_TOKEN_KEY);
        localStorage.removeItem(Constants.USER_KEY);
        this.authenticated.next(false);
        this.logged = false;
    }
    loginWithBasic(email, password) {
        let headers = new HttpHeaders().set("Authorization", "Basic " + btoa(email + ":" + password));
        return this.http.get(this.utils.getEndPoint(PrincipalService.baseServiceUri + "/search/myPrincipal"), {
            headers: headers,
        });
    }
    setLogged(principal) {
        const observable = new Observable((observer) => {
            this.authenticated.next(true);
            this.logged = true;
            localStorage.setItem(Constants.USER_KEY, JSON.stringify(principal));
            observer.next(principal);
            observer.complete();
        });
        return observable;
    }
    search(companyId, username, page) {
        username = username ? username.trim() : "";
        let url = this.utils.getEndPoint(PrincipalService.baseServiceUri + "/search/findCompanyPrincipal");
        let princ = JSON.parse(localStorage.getItem(Constants.USER_KEY));
        companyId = companyId ? companyId : princ.companyId;
        username = username ? username : '';
        let parameters = new HttpParams().set('companyId', companyId).set('username', username).set('sort', 'username').set('username.dir', 'asc');
        if (page) {
            parameters = parameters.set('page', '' + page.number).set('size', '' + page.size);
        }
        let options = { params: parameters };
        return this.http.get(url, options);
    }
    isUserInRoles(requiredRoles) {
        let result = false;
        let userString = localStorage.getItem(Constants.USER_KEY);
        if (!userString || userString.length < 0)
            return false;
        let user = JSON.parse(userString);
        user.profile.sysRoles.forEach(sysRole => {
            requiredRoles.forEach(requiredRole => {
                if (sysRole.fullName == requiredRole) {
                    return result = true;
                }
            });
        });
        return result;
    }
    resetPasswordRequest(email) {
        let url = this.utils.getEndPoint("principalImpls/resetPasswordRequest");
        let options = { params: new HttpParams().set("username", email) };
        return this.http.post(url, {}, options);
    }
    resetPassword(password, resetToken) {
        let url = this.utils.getEndPoint("principalImpls/resetPassword");
        let options = { params: new HttpParams().set("password", password).set("resetToken", resetToken) };
        return this.http.post(url, {}, options);
    }
    changePassword(password) {
        let url = this.utils.getEndPoint("principalImpls/changePassword");
        let options = { params: new HttpParams().set("password", password) };
        return this.http.post(url, {}, options);
    }
    isLogged() {
        let userString = localStorage.getItem(Constants.USER_KEY);
        return userString != null;
    }
    create(principal) {
        let url = this.utils.getEndPoint(PrincipalService.baseServiceUri);
        if (!principal.companyId) {
            let lp = this.getLoggedPrincipal();
            if (!lp) {
                throwError("non è possibile creare l'utente");
            }
            principal.companyId = lp.companyId;
        }
        return this.hateoasService.createObject(url, principal);
    }
    getLoggedPrincipal() {
        let userString = localStorage.getItem(Constants.USER_KEY);
        if (!userString || userString.length < 0)
            return null;
        let user = JSON.parse(userString);
        return user;
    }
}
PrincipalService.baseServiceUri = "principalImpls";
PrincipalService.ɵfac = function PrincipalService_Factory(t) { return new (t || PrincipalService)(ɵɵinject(HttpClient), ɵɵinject(UtilsService), ɵɵinject(HateoasService)); };
PrincipalService.ɵprov = ɵɵdefineInjectable({ token: PrincipalService, factory: PrincipalService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PrincipalService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HttpClient }, { type: UtilsService }, { type: HateoasService }]; }, null); })();

class UserNotifyService {
    constructor() { }
    notifySuccess(message) {
        console.debug(message);
    }
    notifyInfo(message) {
        console.info(message);
    }
    notifyWarning(message) {
        console.warn(message);
    }
    notifyError(message) {
        console.error(message);
    }
}
UserNotifyService.ɵfac = function UserNotifyService_Factory(t) { return new (t || UserNotifyService)(); };
UserNotifyService.ɵprov = ɵɵdefineInjectable({ token: UserNotifyService, factory: UserNotifyService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(UserNotifyService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class LoginComponent {
    constructor(principalService, env, router, userNotify) {
        this.principalService = principalService;
        this.env = env;
        this.router = router;
        this.userNotify = userNotify;
        this.cardTitle = "Login Form";
        this.resetPassswordText = "Hai dimenticato la password? Clicca";
        this.resetLinkText = "qui";
        this.loginSuccessUrl = "/";
        if (env.LOGIN_SUCCESS_URL)
            this.loginSuccessUrl = env.LOGIN_SUCCESS_URL;
        console.debug(this.loginSuccessUrl);
    }
    ngOnInit() {
        this.createForm();
    }
    login() {
        let email = this.form.value.email;
        let password = this.form.value.password;
        this.principalService.login(email, password).subscribe(response => {
            console.debug(this.loginSuccessUrl);
            this.router.navigate([this.loginSuccessUrl]);
        }, error => {
            this.userNotify.notifyWarning("Login error");
        });
    }
    createForm() {
        this.form = new FormGroup({
            email: new FormControl('', [Validators.required, Validators.email]),
            password: new FormControl('', [Validators.required])
            //email: new FormControl('', [Validators.required, Validators.email]),
            //password: new FormControl('', [Validators.required])
        });
    }
}
LoginComponent.ɵfac = function LoginComponent_Factory(t) { return new (t || LoginComponent)(ɵɵdirectiveInject(PrincipalService), ɵɵdirectiveInject('environment'), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(UserNotifyService)); };
LoginComponent.ɵcmp = ɵɵdefineComponent({ type: LoginComponent, selectors: [["dst-sec-login"]], inputs: { cardTitle: "cardTitle", resetPassswordText: "resetPassswordText", resetLinkText: "resetLinkText" }, decls: 30, vars: 5, consts: [["id", "dst-securty-login"], ["id", "dst-securty-login-title"], ["novalidate", "", 3, "formGroup"], ["id", "dst-securty-login-logo-row", 1, "row"], [1, "col", "login-logo", "text-center"], ["src", "/assets/logo_login.png", "alt", "Responsive image", 1, "img-fluid"], [1, "row"], [1, "col"], ["matInput", "", "type", "email", "placeholder", "Inserisci la tua email", "name", "email", "formControlName", "email"], ["matInput", "", "type", "password", "placeholder", "Inserisci la tua password", "name", "password", "formControlName", "password"], ["id", "dst-securty-login-reset-row", 1, "row"], [1, "col-12", "text-align-center"], ["routerLink", "/security/resetPassword"], ["id", "dst-securty-login-button-row", 1, "row"], ["color", "primary", "mat-button", "", "mat-flat-button", "", 1, "login", 3, "disabled", "click"]], template: function LoginComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "mat-card", 0);
        ɵɵelementStart(1, "mat-card-title", 1);
        ɵɵtext(2);
        ɵɵelementEnd();
        ɵɵelementStart(3, "mat-card-content");
        ɵɵelementStart(4, "form", 2);
        ɵɵelementStart(5, "div", 3);
        ɵɵelementStart(6, "div", 4);
        ɵɵelement(7, "img", 5);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(8, "div", 6);
        ɵɵelementStart(9, "div", 7);
        ɵɵelementStart(10, "mat-form-field");
        ɵɵelementStart(11, "mat-label");
        ɵɵtext(12, "Email");
        ɵɵelementEnd();
        ɵɵelement(13, "input", 8);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(14, "div", 6);
        ɵɵelementStart(15, "div", 7);
        ɵɵelementStart(16, "mat-form-field");
        ɵɵelementStart(17, "mat-label");
        ɵɵtext(18, "Password");
        ɵɵelementEnd();
        ɵɵelement(19, "input", 9);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(20, "div", 10);
        ɵɵelementStart(21, "div", 11);
        ɵɵtext(22);
        ɵɵelementStart(23, "a", 12);
        ɵɵtext(24);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(25, "div", 13);
        ɵɵelementStart(26, "div", 7);
        ɵɵelementStart(27, "button", 14);
        ɵɵlistener("click", function LoginComponent_Template_button_click_27_listener() { return ctx.login(); });
        ɵɵtext(28, "ACCEDI");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(29, "br");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(2);
        ɵɵtextInterpolate(ctx.cardTitle);
        ɵɵadvance(2);
        ɵɵproperty("formGroup", ctx.form);
        ɵɵadvance(18);
        ɵɵtextInterpolate1("", ctx.resetPassswordText, " ");
        ɵɵadvance(2);
        ɵɵtextInterpolate(ctx.resetLinkText);
        ɵɵadvance(3);
        ɵɵproperty("disabled", ctx.form.invalid);
    } }, directives: [MatCard, MatCardTitle, MatCardContent, ɵangular_packages_forms_forms_y, NgControlStatusGroup, FormGroupDirective, MatFormField, MatLabel, MatInput, DefaultValueAccessor, NgControlStatus, FormControlName, RouterLinkWithHref, MatButton], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(LoginComponent, [{
        type: Component,
        args: [{
                selector: 'dst-sec-login',
                templateUrl: './login.component.html',
                styleUrls: ['./login.component.css']
            }]
    }], function () { return [{ type: PrincipalService }, { type: undefined, decorators: [{
                type: Inject,
                args: ['environment']
            }] }, { type: Router }, { type: UserNotifyService }]; }, { cardTitle: [{
            type: Input
        }], resetPassswordText: [{
            type: Input
        }], resetLinkText: [{
            type: Input
        }] }); })();

registerLocaleData(localeIt);
const MY_DATE_FORMATS = {
    parse: {
        dateInput: 'L',
    },
    display: {
        dateInput: 'L',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'L',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};
class MaterialModule {
}
MaterialModule.ɵmod = ɵɵdefineNgModule({ type: MaterialModule });
MaterialModule.ɵinj = ɵɵdefineInjector({ factory: function MaterialModule_Factory(t) { return new (t || MaterialModule)(); }, providers: [
        { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
        // {provide: DateAdapter, useClass: ItalianDateAdapter, deps: [MAT_DATE_LOCALE, Platform]},
        { provide: MAT_DATE_LOCALE, useValue: 'it-IT' }
    ], imports: [[
            MatSidenavModule,
            MatButtonModule,
            MatMenuModule,
            MatToolbarModule,
            MatIconModule,
            MatCardModule,
            MatInputModule,
            MatCheckboxModule,
            MatFormFieldModule,
            MatSelectModule,
            MatButtonToggleModule,
            MatDialogModule,
            MatChipsModule,
            MatDatepickerModule,
            MatProgressSpinnerModule,
            MatSnackBarModule,
            MatTabsModule,
            MatDatepickerModule,
            MatNativeDateModule,
            MatGridListModule,
            MatPaginatorModule,
            MatTableModule,
            MatCheckboxModule,
            MatAutocompleteModule,
            MatTooltipModule,
            MatSortModule,
            MatExpansionModule
        ], MatSidenavModule,
        MatButtonModule,
        MatMenuModule,
        MatToolbarModule,
        MatIconModule,
        MatCardModule,
        MatInputModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatSelectModule,
        MatButtonToggleModule,
        MatDialogModule,
        MatChipsModule,
        MatDatepickerModule,
        MatProgressSpinnerModule,
        MatSnackBarModule,
        MatTabsModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatGridListModule,
        MatPaginatorModule,
        MatTableModule,
        MatCheckboxModule,
        MatAutocompleteModule,
        MatTooltipModule,
        MatSortModule,
        MatExpansionModule,
        MatListModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(MaterialModule, { imports: [MatSidenavModule,
        MatButtonModule,
        MatMenuModule,
        MatToolbarModule,
        MatIconModule,
        MatCardModule,
        MatInputModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatSelectModule,
        MatButtonToggleModule,
        MatDialogModule,
        MatChipsModule,
        MatDatepickerModule,
        MatProgressSpinnerModule,
        MatSnackBarModule,
        MatTabsModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatGridListModule,
        MatPaginatorModule,
        MatTableModule,
        MatCheckboxModule,
        MatAutocompleteModule,
        MatTooltipModule,
        MatSortModule,
        MatExpansionModule], exports: [MatSidenavModule,
        MatButtonModule,
        MatMenuModule,
        MatToolbarModule,
        MatIconModule,
        MatCardModule,
        MatInputModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatSelectModule,
        MatButtonToggleModule,
        MatDialogModule,
        MatChipsModule,
        MatDatepickerModule,
        MatProgressSpinnerModule,
        MatSnackBarModule,
        MatTabsModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatGridListModule,
        MatPaginatorModule,
        MatTableModule,
        MatCheckboxModule,
        MatAutocompleteModule,
        MatTooltipModule,
        MatSortModule,
        MatExpansionModule,
        MatListModule] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(MaterialModule, [{
        type: NgModule,
        args: [{
                imports: [
                    MatSidenavModule,
                    MatButtonModule,
                    MatMenuModule,
                    MatToolbarModule,
                    MatIconModule,
                    MatCardModule,
                    MatInputModule,
                    MatCheckboxModule,
                    MatFormFieldModule,
                    MatSelectModule,
                    MatButtonToggleModule,
                    MatDialogModule,
                    MatChipsModule,
                    MatDatepickerModule,
                    MatProgressSpinnerModule,
                    MatSnackBarModule,
                    MatTabsModule,
                    MatDatepickerModule,
                    MatNativeDateModule,
                    MatGridListModule,
                    MatPaginatorModule,
                    MatTableModule,
                    MatCheckboxModule,
                    MatAutocompleteModule,
                    MatTooltipModule,
                    MatSortModule,
                    MatExpansionModule
                ],
                providers: [
                    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
                    // {provide: DateAdapter, useClass: ItalianDateAdapter, deps: [MAT_DATE_LOCALE, Platform]},
                    { provide: MAT_DATE_LOCALE, useValue: 'it-IT' }
                ],
                exports: [
                    MatSidenavModule,
                    MatButtonModule,
                    MatMenuModule,
                    MatToolbarModule,
                    MatIconModule,
                    MatCardModule,
                    MatInputModule,
                    MatCheckboxModule,
                    MatFormFieldModule,
                    MatSelectModule,
                    MatButtonToggleModule,
                    MatDialogModule,
                    MatChipsModule,
                    MatDatepickerModule,
                    MatProgressSpinnerModule,
                    MatSnackBarModule,
                    MatTabsModule,
                    MatDatepickerModule,
                    MatNativeDateModule,
                    MatGridListModule,
                    MatPaginatorModule,
                    MatTableModule,
                    MatCheckboxModule,
                    MatAutocompleteModule,
                    MatTooltipModule,
                    MatSortModule,
                    MatExpansionModule,
                    MatListModule
                ]
            }]
    }], null, null); })();

class HandleErrorServiceService {
    constructor() { }
    handleError(err) {
        console.debug("err    ", err);
    }
}
HandleErrorServiceService.ɵfac = function HandleErrorServiceService_Factory(t) { return new (t || HandleErrorServiceService)(); };
HandleErrorServiceService.ɵprov = ɵɵdefineInjectable({ token: HandleErrorServiceService, factory: HandleErrorServiceService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(HandleErrorServiceService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

// @Injectable()
// export class HTTPStatus {
//   private requestInFlight$: BehaviorSubject<boolean>;  
//   constructor() {
//     this.requestInFlight$ = new BehaviorSubject(false);
//   }
//   setHttpStatus(inFlight: boolean) {
//     this.requestInFlight$.next(inFlight);
//   }
//   getHttpStatus(): Observable<boolean> {
//     return this.requestInFlight$.asObservable();
//   }
// }
class InterceptorService {
    constructor(router, principalService, handleErrorService) {
        this.router = router;
        this.principalService = principalService;
        this.handleErrorService = handleErrorService;
    }
    intercept(req, next) {
        let token = localStorage.getItem(Constants.AUTH_TOKEN_KEY);
        let authReq = req;
        if (token != null) {
            authReq = req.clone({ headers: req.headers.set(Constants.AUTH_TOKEN_KEY, token) });
        }
        this.preCallRestApi(req);
        // this.status.setHttpStatus(true);
        return next.handle(authReq)
            .pipe(tap(event => {
            if (event instanceof HttpResponse) {
                if (event.headers.get("x-auth-token") != null && req.url.indexOf("/public/") < 0) {
                    localStorage.setItem("x-auth-token", event.headers.get("x-auth-token"));
                }
                return event;
            }
        }), catchError(err => {
            console.debug(err);
            if (err instanceof HttpErrorResponse && err.status === 0) {
            }
            else if (err instanceof HttpErrorResponse && err.status === 401) {
                this.principalService.logout();
                this.router.navigate(['/security/login']);
                this.handleError(err);
            }
            else if (err instanceof HttpErrorResponse && err.status === 404) {
                console.log("error 404 should be managed by application", err);
            }
            else
                this.handleError(err);
            return throwError(err);
        }), finalize(() => {
            this.postCallRestApi(req);
            // this.status.setHttpStatus(false);
        }));
    }
    handleError(err) {
        if (this.handleErrorService)
            this.handleErrorService.handleError(err);
    }
    preCallRestApi(request) {
    }
    postCallRestApi(request) {
    }
}
InterceptorService.ɵfac = function InterceptorService_Factory(t) { return new (t || InterceptorService)(ɵɵinject(Router), ɵɵinject(PrincipalService), ɵɵinject(HandleErrorServiceService)); };
InterceptorService.ɵprov = ɵɵdefineInjectable({ token: InterceptorService, factory: InterceptorService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(InterceptorService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: Router }, { type: PrincipalService }, { type: HandleErrorServiceService }]; }, null); })();

class Pages {
}
class HateoasEmbedded {
    constructor() {
        this.items = [];
        this._embedded = {};
    }
    init(object) {
        this._embedded = object["_embedded"];
        this.page = object["page"];
        // console.debug("object:");
        // console.debug(object);
        // console.debug("embedded");
        // console.debug(this._embedded);
    }
    getObects(property) {
        if (this._embedded != null)
            return this._embedded[property];
        return null;
    }
}

function SearchPrincipalComponent_mat_header_cell_17_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-header-cell");
    ɵɵtext(1, "User Name");
    ɵɵelementEnd();
} }
function SearchPrincipalComponent_mat_cell_18_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-cell");
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const principal_r15 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate(principal_r15.username);
} }
function SearchPrincipalComponent_mat_header_cell_20_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-header-cell");
    ɵɵtext(1, "Email");
    ɵɵelementEnd();
} }
function SearchPrincipalComponent_mat_cell_21_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-cell");
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const principal_r16 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate(principal_r16.email);
} }
function SearchPrincipalComponent_mat_header_cell_23_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-header-cell");
    ɵɵtext(1, "Data Creazione");
    ɵɵelementEnd();
} }
function SearchPrincipalComponent_mat_cell_24_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-cell");
    ɵɵtext(1);
    ɵɵpipe(2, "date");
    ɵɵelementEnd();
} if (rf & 2) {
    const principal_r17 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate(ɵɵpipeBind2(2, 1, principal_r17.createDate, "dd/MM/yyyy - HH:mm"));
} }
function SearchPrincipalComponent_mat_header_cell_26_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-header-cell");
    ɵɵtext(1, "Data Ultimo Accesso");
    ɵɵelementEnd();
} }
function SearchPrincipalComponent_mat_cell_27_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-cell");
    ɵɵtext(1);
    ɵɵpipe(2, "date");
    ɵɵelementEnd();
} if (rf & 2) {
    const principal_r18 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate(ɵɵpipeBind2(2, 1, principal_r18.lastAccess, "dd/MM/yyyy - HH:mm"));
} }
function SearchPrincipalComponent_mat_header_cell_29_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-header-cell");
    ɵɵtext(1, "Tentivi Accesso Falliti");
    ɵɵelementEnd();
} }
function SearchPrincipalComponent_mat_cell_30_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-cell");
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const principal_r19 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate(principal_r19.trialCount);
} }
function SearchPrincipalComponent_mat_header_cell_32_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-header-cell");
    ɵɵtext(1, "azioni");
    ɵɵelementEnd();
} }
function SearchPrincipalComponent_mat_cell_33_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r26 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", 22);
    ɵɵlistener("click", function SearchPrincipalComponent_mat_cell_33_button_1_Template_button_click_0_listener() { ɵɵrestoreView(_r26); const principal_r20 = ɵɵnextContext().$implicit; const ctx_r24 = ɵɵnextContext(); return ctx_r24.resetTrialCount(principal_r20); });
    ɵɵelementStart(1, "mat-icon", 27);
    ɵɵtext(2, "clear_all");
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function SearchPrincipalComponent_mat_cell_33_mat_icon_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-icon", 28);
    ɵɵtext(1, "check");
    ɵɵelementEnd();
} }
function SearchPrincipalComponent_mat_cell_33_mat_icon_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-icon", 29);
    ɵɵtext(1, "block");
    ɵɵelementEnd();
} }
const _c0 = function () { return ["/security/principal"]; };
const _c1 = function (a0) { return { self: a0 }; };
function SearchPrincipalComponent_mat_cell_33_Template(rf, ctx) { if (rf & 1) {
    const _r28 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "mat-cell");
    ɵɵtemplate(1, SearchPrincipalComponent_mat_cell_33_button_1_Template, 3, 0, "button", 21);
    ɵɵelementStart(2, "button", 22);
    ɵɵlistener("click", function SearchPrincipalComponent_mat_cell_33_Template_button_click_2_listener() { ɵɵrestoreView(_r28); const principal_r20 = ctx.$implicit; const ctx_r27 = ɵɵnextContext(); return ctx_r27.toggleEnabled(principal_r20); });
    ɵɵtemplate(3, SearchPrincipalComponent_mat_cell_33_mat_icon_3_Template, 2, 0, "mat-icon", 23);
    ɵɵtemplate(4, SearchPrincipalComponent_mat_cell_33_mat_icon_4_Template, 2, 0, "mat-icon", 24);
    ɵɵelementEnd();
    ɵɵelementStart(5, "a", 25);
    ɵɵelementStart(6, "mat-icon", 26);
    ɵɵtext(7, "edit");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const principal_r20 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", principal_r20.trialCount > 0);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", principal_r20.enabled);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !principal_r20.enabled);
    ɵɵadvance(1);
    ɵɵproperty("routerLink", ɵɵpureFunction0(5, _c0))("queryParams", ɵɵpureFunction1(6, _c1, principal_r20._links.self.href));
} }
function SearchPrincipalComponent_mat_header_row_34_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "mat-header-row");
} }
function SearchPrincipalComponent_mat_row_35_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "mat-row");
} }
class SearchPrincipalComponent {
    constructor(principalService, hateoasService, userNotifyService, utils) {
        this.principalService = principalService;
        this.hateoasService = hateoasService;
        this.userNotifyService = userNotifyService;
        this.utils = utils;
        this.principals = [];
        this.dataSource = new MatTableDataSource();
        this.displayedColumns = ['username', 'email', 'trialCount', 'createDate', 'lastAccess', 'enabled']; //'avanzamento'
    }
    ngOnInit() {
        this.search();
    }
    search() {
        this.username = this.username ? this.username : '';
        this.principalService.search(1, this.username, this.page).subscribe(result => {
            let he = new HateoasEmbedded();
            he.init(result);
            this.principals = he.getObects('principalImpls');
            this.page = he.page;
            this.dataSource = new MatTableDataSource(he.getObects('principalImpls'));
        });
    }
    onPaginateChange(pageEvent) {
        UtilsService.fillPageObj(pageEvent, this.page);
        this.search();
    }
    resetTrialCount(principal) {
        principal.trialCount = 0;
        this.hateoasService.updateObject(principal).subscribe(result => {
            console.log(result);
            this.userNotifyService.notifySuccess("Login error reset success");
        }, error => {
            this.userNotifyService.notifyError("Login error reset error");
        });
    }
    toggleEnabled(principal) {
        principal.enabled = !principal.enabled;
        console.debug(principal);
        this.hateoasService.updateObject(principal).subscribe(result => {
            console.log(result);
        });
    }
}
SearchPrincipalComponent.ɵfac = function SearchPrincipalComponent_Factory(t) { return new (t || SearchPrincipalComponent)(ɵɵdirectiveInject(PrincipalService), ɵɵdirectiveInject(HateoasService), ɵɵdirectiveInject(UserNotifyService), ɵɵdirectiveInject(UtilsService)); };
SearchPrincipalComponent.ɵcmp = ɵɵdefineComponent({ type: SearchPrincipalComponent, selectors: [["dst-sec-search-principal"]], decls: 36, vars: 7, consts: [[1, "table-header"], [1, "container-fluid"], [1, "row"], [1, "col"], ["matInput", "", "type", "text", "placeholder", "Cerca", "id", "searchInput", 3, "ngModel", "ngModelChange", "keyup"], [3, "length", "pageSize", "page"], [1, "col-md-auto"], ["routerLink", "/security/principal", "routerLinkActive", "active", "mat-fab", "", "color", "primary"], [1, "table-container"], [3, "dataSource"], ["table", ""], ["matColumnDef", "username"], [4, "matHeaderCellDef"], [4, "matCellDef"], ["matColumnDef", "email"], ["matColumnDef", "createDate"], ["matColumnDef", "lastAccess"], ["matColumnDef", "trialCount"], ["matColumnDef", "enabled"], [4, "matHeaderRowDef", "matHeaderRowDefSticky"], [4, "matRowDef", "matRowDefColumns"], ["mat-icon-button", "", 3, "click", 4, "ngIf"], ["mat-icon-button", "", 3, "click"], ["color", "primary", "title", "disable", 4, "ngIf"], ["color", "warn", "title", "enable", 4, "ngIf"], ["mat-icon-button", "", 3, "routerLink", "queryParams"], ["color", "primary", "title", "edit"], ["color", "warn", "title", "azzera errori login"], ["color", "primary", "title", "disable"], ["color", "warn", "title", "enable"]], template: function SearchPrincipalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div");
        ɵɵelementStart(1, "div", 0);
        ɵɵelementStart(2, "div", 1);
        ɵɵelementStart(3, "div", 2);
        ɵɵelementStart(4, "div", 3);
        ɵɵelementStart(5, "mat-form-field");
        ɵɵelementStart(6, "input", 4);
        ɵɵlistener("ngModelChange", function SearchPrincipalComponent_Template_input_ngModelChange_6_listener($event) { return ctx.username = $event; })("keyup", function SearchPrincipalComponent_Template_input_keyup_6_listener() { return ctx.search(); });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(7, "div", 3);
        ɵɵelementStart(8, "mat-paginator", 5);
        ɵɵlistener("page", function SearchPrincipalComponent_Template_mat_paginator_page_8_listener($event) { return ctx.onPaginateChange($event); });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(9, "div", 6);
        ɵɵelementStart(10, "a", 7);
        ɵɵelementStart(11, "mat-icon");
        ɵɵtext(12, "add");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(13, "div", 8);
        ɵɵelementStart(14, "mat-table", 9, 10);
        ɵɵelementContainerStart(16, 11);
        ɵɵtemplate(17, SearchPrincipalComponent_mat_header_cell_17_Template, 2, 0, "mat-header-cell", 12);
        ɵɵtemplate(18, SearchPrincipalComponent_mat_cell_18_Template, 2, 1, "mat-cell", 13);
        ɵɵelementContainerEnd();
        ɵɵelementContainerStart(19, 14);
        ɵɵtemplate(20, SearchPrincipalComponent_mat_header_cell_20_Template, 2, 0, "mat-header-cell", 12);
        ɵɵtemplate(21, SearchPrincipalComponent_mat_cell_21_Template, 2, 1, "mat-cell", 13);
        ɵɵelementContainerEnd();
        ɵɵelementContainerStart(22, 15);
        ɵɵtemplate(23, SearchPrincipalComponent_mat_header_cell_23_Template, 2, 0, "mat-header-cell", 12);
        ɵɵtemplate(24, SearchPrincipalComponent_mat_cell_24_Template, 3, 4, "mat-cell", 13);
        ɵɵelementContainerEnd();
        ɵɵelementContainerStart(25, 16);
        ɵɵtemplate(26, SearchPrincipalComponent_mat_header_cell_26_Template, 2, 0, "mat-header-cell", 12);
        ɵɵtemplate(27, SearchPrincipalComponent_mat_cell_27_Template, 3, 4, "mat-cell", 13);
        ɵɵelementContainerEnd();
        ɵɵelementContainerStart(28, 17);
        ɵɵtemplate(29, SearchPrincipalComponent_mat_header_cell_29_Template, 2, 0, "mat-header-cell", 12);
        ɵɵtemplate(30, SearchPrincipalComponent_mat_cell_30_Template, 2, 1, "mat-cell", 13);
        ɵɵelementContainerEnd();
        ɵɵelementContainerStart(31, 18);
        ɵɵtemplate(32, SearchPrincipalComponent_mat_header_cell_32_Template, 2, 0, "mat-header-cell", 12);
        ɵɵtemplate(33, SearchPrincipalComponent_mat_cell_33_Template, 8, 8, "mat-cell", 13);
        ɵɵelementContainerEnd();
        ɵɵtemplate(34, SearchPrincipalComponent_mat_header_row_34_Template, 1, 0, "mat-header-row", 19);
        ɵɵtemplate(35, SearchPrincipalComponent_mat_row_35_Template, 1, 0, "mat-row", 20);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(6);
        ɵɵproperty("ngModel", ctx.username);
        ɵɵadvance(2);
        ɵɵproperty("length", ctx.page == null ? null : ctx.page.totalElements)("pageSize", ctx.page == null ? null : ctx.page.size);
        ɵɵadvance(6);
        ɵɵproperty("dataSource", ctx.dataSource);
        ɵɵadvance(20);
        ɵɵproperty("matHeaderRowDef", ctx.displayedColumns)("matHeaderRowDefSticky", true);
        ɵɵadvance(1);
        ɵɵproperty("matRowDefColumns", ctx.displayedColumns);
    } }, directives: [MatFormField, MatInput, DefaultValueAccessor, NgControlStatus, NgModel, MatPaginator, RouterLinkWithHref, MatAnchor, RouterLinkActive, MatIcon, MatTable, MatColumnDef, MatHeaderCellDef, MatCellDef, MatHeaderRowDef, MatRowDef, MatHeaderCell, MatCell, NgIf, MatButton, MatHeaderRow, MatRow], pipes: [DatePipe], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(SearchPrincipalComponent, [{
        type: Component,
        args: [{
                selector: 'dst-sec-search-principal',
                templateUrl: './search-principal.component.html',
                styleUrls: ['./search-principal.component.css']
            }]
    }], function () { return [{ type: PrincipalService }, { type: HateoasService }, { type: UserNotifyService }, { type: UtilsService }]; }, null); })();

class Hateoas {
    constructor(values = {}) {
        Object.assign(this, values);
    }
    getIdBySelf() {
        if (this._links && this._links.self)
            return Number(this._links.self.href.split("/").reverse()[0]);
        return null;
    }
    isPesisted() {
        return this._links ? true : false;
    }
}

class Principal extends Hateoas {
}

class Profile extends Hateoas {
}

class ProfileService extends HateoasService {
    constructor(http, utils) {
        super(http);
        this.utils = utils;
    }
    list(page) {
        let pageParam = "";
        if (page)
            pageParam = page.getPageQueryParams();
        return this.get(this.utils.getEndPoint(ProfileService.PROFILE_URI) + "?projection=" + "profileWithSysRoles&sort=name,asc&" + pageParam);
    }
    save(profile) {
        profile = new Profile(profile);
        if (profile._links) {
            delete profile.sysRoles;
            delete profile.id;
            return this.updateObject(profile);
        }
        return this.createObject(this.utils.getEndPoint("profileImpls"), profile);
    }
    countProfileUsers(profile) {
        profile = new Profile(profile);
        let id = profile.id > 0 ? profile.id : profile.getIdBySelf();
        return this.get(this.utils.getEndPoint(ProfileService.PROFILE_URI) + "/search/countProfileUsers?id=" + id);
    }
}
ProfileService.PROFILE_URI = "profileImpls";
ProfileService.ɵfac = function ProfileService_Factory(t) { return new (t || ProfileService)(ɵɵinject(HttpClient), ɵɵinject(UtilsService)); };
ProfileService.ɵprov = ɵɵdefineInjectable({ token: ProfileService, factory: ProfileService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ProfileService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HttpClient }, { type: UtilsService }]; }, null); })();

function ProfileComponent_mat_option_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-option", 7);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const profile_r3 = ctx.$implicit;
    ɵɵproperty("value", profile_r3);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", profile_r3.name, " ");
} }
function ProfileComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 1);
    ɵɵelementStart(1, "p");
    ɵɵelementStart(2, "span");
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(3);
    ɵɵtextInterpolate(ctx_r1.userProfile.description);
} }
function ProfileComponent_div_10_mat_list_item_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-list-item");
    ɵɵelementStart(1, "mat-icon");
    ɵɵtext(2, "label");
    ɵɵelementEnd();
    ɵɵtext(3);
    ɵɵelementEnd();
} if (rf & 2) {
    const sysRole_r5 = ctx.$implicit;
    ɵɵadvance(3);
    ɵɵtextInterpolate1(" ", sysRole_r5.fullName, " ");
} }
function ProfileComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 1);
    ɵɵelementStart(1, "span");
    ɵɵtext(2, "ruoli associati al profilo");
    ɵɵelementEnd();
    ɵɵelementStart(3, "mat-list");
    ɵɵtemplate(4, ProfileComponent_div_10_mat_list_item_4_Template, 4, 1, "mat-list-item", 8);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵadvance(4);
    ɵɵproperty("ngForOf", ctx_r2.userProfile.sysRoles);
} }
class ProfileComponent {
    constructor(profileService) {
        this.profileService = profileService;
        this.disabled = true;
        this.newProfile = new EventEmitter();
        // this.userProfile=new Profile();
        // this.userProfile.sysRoles=[];
    }
    ngOnInit() {
        if (this.principal._links) {
            this.disabled = false;
            if (this.principal.profile != null) {
                this.userProfile = this.principal.profile;
                console.debug("init profile");
                console.debug(this.userProfile);
            }
        }
        console.debug('init select disabled?' + this.disabled);
        this.profileService.list().subscribe(result => {
            let emb = new HateoasEmbedded();
            emb.init(result);
            this.profiles = emb.getObects("profileImpls");
        });
    }
    changeProfile(event) {
        console.debug(this.principal.profile);
        console.debug(event);
        if (this.principal.profile == null || event.value._links.self != this.principal.profile._links.self) {
            this.newProfile.emit(event.value._links.self.href);
        }
        console.debug(event);
    }
    ngOnChanges() {
        if (this.principal._links) {
            this.disabled = false;
            if (this.principal.profile)
                this.userProfile = this.principal.profile;
        }
    }
    compareObjects(o1, o2) {
        console.debug(o1);
        console.debug(o2);
        return o1._links.self.href == o2._links.self.href;
        return true;
    }
}
ProfileComponent.ɵfac = function ProfileComponent_Factory(t) { return new (t || ProfileComponent)(ɵɵdirectiveInject(ProfileService)); };
ProfileComponent.ɵcmp = ɵɵdefineComponent({ type: ProfileComponent, selectors: [["dst-sec-profile"]], inputs: { principal: "principal" }, outputs: { newProfile: "newProfile" }, features: [ɵɵNgOnChangesFeature], decls: 11, vars: 6, consts: [[1, "row"], [1, "col"], [3, "compareWith", "value", "disabled", "valueChange", "selectionChange"], [3, "value", 4, "ngFor", "ngForOf"], ["id", "profileDetail", 1, "row"], ["class", "col", 4, "ngIf"], ["id", "profileRoles", 1, "row"], [3, "value"], [4, "ngFor", "ngForOf"]], template: function ProfileComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "mat-form-field");
        ɵɵelementStart(3, "mat-label");
        ɵɵtext(4, "Profilo utente");
        ɵɵelementEnd();
        ɵɵelementStart(5, "mat-select", 2);
        ɵɵlistener("valueChange", function ProfileComponent_Template_mat_select_valueChange_5_listener($event) { return ctx.userProfile = $event; })("selectionChange", function ProfileComponent_Template_mat_select_selectionChange_5_listener($event) { return ctx.changeProfile($event); });
        ɵɵtemplate(6, ProfileComponent_mat_option_6_Template, 2, 2, "mat-option", 3);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(7, "div", 4);
        ɵɵtemplate(8, ProfileComponent_div_8_Template, 4, 1, "div", 5);
        ɵɵelementEnd();
        ɵɵelementStart(9, "div", 6);
        ɵɵtemplate(10, ProfileComponent_div_10_Template, 5, 1, "div", 5);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(5);
        ɵɵproperty("compareWith", ctx.compareObjects)("value", ctx.userProfile)("disabled", ctx.disabled);
        ɵɵadvance(1);
        ɵɵproperty("ngForOf", ctx.profiles);
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ctx.userProfile);
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ctx.userProfile);
    } }, directives: [MatFormField, MatLabel, MatSelect, NgForOf, NgIf, MatOption, MatList, MatListItem, MatIcon], styles: ["#profileDetail[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{list-style-type:none}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ProfileComponent, [{
        type: Component,
        args: [{
                selector: 'dst-sec-profile',
                templateUrl: './profile.component.html',
                styleUrls: ['./profile.component.css']
            }]
    }], function () { return [{ type: ProfileService }]; }, { principal: [{
            type: Input
        }], newProfile: [{
            type: Output
        }] }); })();

class EditPrincipalComponent {
    constructor(principalService, hateoasService, activatedRoute, utilService, userNotifyService) {
        this.principalService = principalService;
        this.hateoasService = hateoasService;
        this.activatedRoute = activatedRoute;
        this.utilService = utilService;
        this.userNotifyService = userNotifyService;
        this.principalChange = new EventEmitter();
        this.principal = new Principal();
        this.passwordRegex = Constants.DEFAULT_PASSWORD_REGEX;
        this.isProfileChanged = false;
        if (utilService.getEnvProperty("passwordRegex")) {
            this.passwordRegex = utilService.getEnvProperty("passwordRegex");
        }
    }
    ngOnInit() {
        // this.cratePrincipalForm();
        this.activatedRoute.queryParamMap.subscribe(queryParams => {
            console.debug(queryParams);
            if (queryParams.get('self')) {
                this.loadPrincipal(queryParams.get('self'));
            }
            else {
                this.principal = new Principal();
                this.principal.enabled = true;
            }
            console.debug(this.principal);
        });
    }
    loadPrincipal(selfUrl) {
        let stocazzo;
        this.hateoasService.get(selfUrl).pipe(switchMap(result => {
            stocazzo = new Principal(result);
            console.debug(stocazzo);
            let link = stocazzo._links.profile.href.replace('{\?projection}', '\?projection=principalProfile');
            this.principalChange.emit(stocazzo);
            return this.hateoasService.get(link);
        })).subscribe(result => {
            stocazzo.profile = new Profile(result);
            this.principal = stocazzo;
            this.principalChange.emit(this.principal);
            console.debug('ma va fa');
            console.debug(this.principal.profile);
        }, error => {
            this.principal = stocazzo;
        });
    }
    savePrincipal() {
        console.debug(this.principal);
        // se il principal deve essere creato non gli posso assegnare il profilo 
        // nel if quindi controllo che sia già persistente prima di associaglio il profilo
        if (this.principal.isPesisted()) {
            let profile = this.principal.profile;
            if (this.newProfileSelfLink)
                this.principal.profile = this.newProfileSelfLink;
            else
                delete this.principal.profile;
            console.debug(this.principal);
            this.hateoasService.updateObject(this.principal).subscribe(result => {
                console.debug("update");
                console.debug(result);
                if (this.newProfileSelfLink) {
                    this.hateoasService.linkObject(this.principal._links.profile.href, this.newProfileSelfLink).subscribe(result => {
                        profile = new Profile(result);
                        this.userNotifyService.notifyInfo("User successfully saved");
                        this.loadPrincipal(result._links.self.href);
                        console.debug(this.newProfileSelfLink);
                        this.principal.profile = profile;
                    });
                }
                else {
                    this.loadPrincipal(result._links.self.href);
                    console.debug(this.newProfileSelfLink);
                    this.principal.profile = profile;
                }
            }, error => {
                this.userNotifyService.notifyError("errore nel salvataggio dell'utente");
            });
        }
        else {
            this.principalService.create(this.principal).subscribe(result => {
                console.debug(result);
                this.userNotifyService.notifyInfo("User successfully saved");
                this.loadPrincipal(result._links.self.href);
            }, error => {
                this.userNotifyService.notifyError("errore nel salvataggio dell'utente");
            });
        }
    }
    profileChanged(event) {
        console.debug("profileChanged");
        console.debug(event);
        if (this.principal.profile && event != this.principal.profile._links.self.href) {
            this.isProfileChanged = true;
            this.newProfileSelfLink = event;
            console.debug("new profile setted:" + this.newProfileSelfLink);
        }
        else if (!this.principal.profile) {
            this.isProfileChanged = true;
            this.newProfileSelfLink = event;
            console.debug("profile setted for new user:" + this.newProfileSelfLink);
        }
        else {
            this.isProfileChanged = false;
            console.debug("no change in profile");
        }
    }
}
EditPrincipalComponent.ɵfac = function EditPrincipalComponent_Factory(t) { return new (t || EditPrincipalComponent)(ɵɵdirectiveInject(PrincipalService), ɵɵdirectiveInject(HateoasService), ɵɵdirectiveInject(ActivatedRoute), ɵɵdirectiveInject(UtilsService), ɵɵdirectiveInject(UserNotifyService)); };
EditPrincipalComponent.ɵcmp = ɵɵdefineComponent({ type: EditPrincipalComponent, selectors: [["dst-sec-edit-principal"]], outputs: { principalChange: "principalChange" }, decls: 45, vars: 13, consts: [[1, "row"], [1, "col"], [1, "mat-card-title"], [1, "mat-card-subtitle"], ["id", "companyIdInfo"], ["principalForm", "ngForm"], ["matInput", "", "type", "email", "name", "email", "required", "", "email", "", "placeholder", "email utente", 3, "ngModel", "ngModelChange"], ["matInput", "", "type", "text", "name", "username", "required", "", "minlength", "4", "placeholder", "nome utente", 3, "ngModel", "ngModelChange"], ["name", "enabled", 3, "ngModel", "ngModelChange"], ["matInput", "", "type", "password", "name", "password", "minlength", "8", "placeholder", "password", 3, "pattern", "ngModel", "ngModelChange"], [3, "principal", "newProfile"], ["color", "primary", "mat-button", "", "mat-flat-button", "", 3, "disabled", "click"]], template: function EditPrincipalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "div", 0);
        ɵɵelementStart(3, "div", 1);
        ɵɵelementStart(4, "h3", 2);
        ɵɵtext(5);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(6, "div", 0);
        ɵɵelementStart(7, "div", 1);
        ɵɵelementStart(8, "p", 3);
        ɵɵtext(9);
        ɵɵpipe(10, "date");
        ɵɵelementStart(11, "span", 4);
        ɵɵtext(12);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(13, "div", 0);
        ɵɵelementStart(14, "div", 1);
        ɵɵelementStart(15, "form", null, 5);
        ɵɵelementStart(17, "div", 0);
        ɵɵelementStart(18, "div", 1);
        ɵɵelementStart(19, "mat-form-field");
        ɵɵelementStart(20, "mat-label");
        ɵɵtext(21, "user email");
        ɵɵelementEnd();
        ɵɵelementStart(22, "input", 6);
        ɵɵlistener("ngModelChange", function EditPrincipalComponent_Template_input_ngModelChange_22_listener($event) { return ctx.principal.email = $event; });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(23, "div", 0);
        ɵɵelementStart(24, "div", 1);
        ɵɵelementStart(25, "mat-form-field");
        ɵɵelementStart(26, "mat-label");
        ɵɵtext(27, "user name");
        ɵɵelementEnd();
        ɵɵelementStart(28, "input", 7);
        ɵɵlistener("ngModelChange", function EditPrincipalComponent_Template_input_ngModelChange_28_listener($event) { return ctx.principal.username = $event; });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(29, "div", 0);
        ɵɵelementStart(30, "div", 1);
        ɵɵelementStart(31, "mat-checkbox", 8);
        ɵɵlistener("ngModelChange", function EditPrincipalComponent_Template_mat_checkbox_ngModelChange_31_listener($event) { return ctx.principal.enabled = $event; });
        ɵɵtext(32, "Attivo");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(33, "div", 0);
        ɵɵelementStart(34, "div", 1);
        ɵɵelementStart(35, "mat-form-field");
        ɵɵelementStart(36, "mat-label");
        ɵɵtext(37, "password");
        ɵɵelementEnd();
        ɵɵelementStart(38, "input", 9);
        ɵɵlistener("ngModelChange", function EditPrincipalComponent_Template_input_ngModelChange_38_listener($event) { return ctx.principal.password = $event; });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(39, "div", 1);
        ɵɵelementStart(40, "dst-sec-profile", 10);
        ɵɵlistener("newProfile", function EditPrincipalComponent_Template_dst_sec_profile_newProfile_40_listener($event) { return ctx.profileChanged($event); });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(41, "div", 0);
        ɵɵelementStart(42, "div", 1);
        ɵɵelementStart(43, "button", 11);
        ɵɵlistener("click", function EditPrincipalComponent_Template_button_click_43_listener() { return ctx.savePrincipal(); });
        ɵɵtext(44, "Conferma");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵɵreference(16);
        ɵɵadvance(5);
        ɵɵtextInterpolate(ctx.principal._links ? "Dati Utente " + ctx.principal.username : "nuovo utente");
        ɵɵadvance(4);
        ɵɵtextInterpolate1("ultimo accesso ", ɵɵpipeBind2(10, 10, ctx.principal.lastAccess, "dd/MM/yyyy hh:mm"), " ");
        ɵɵadvance(3);
        ɵɵtextInterpolate1("company ", ctx.principal.companyId, "");
        ɵɵadvance(10);
        ɵɵproperty("ngModel", ctx.principal.email);
        ɵɵadvance(6);
        ɵɵproperty("ngModel", ctx.principal.username);
        ɵɵadvance(3);
        ɵɵproperty("ngModel", ctx.principal.enabled);
        ɵɵadvance(7);
        ɵɵpropertyInterpolate("pattern", ctx.passwordRegex);
        ɵɵproperty("ngModel", ctx.principal.password);
        ɵɵadvance(2);
        ɵɵproperty("principal", ctx.principal);
        ɵɵadvance(3);
        ɵɵproperty("disabled", !_r0.form.valid);
    } }, directives: [ɵangular_packages_forms_forms_y, NgControlStatusGroup, NgForm, MatFormField, MatLabel, MatInput, DefaultValueAccessor, RequiredValidator, EmailValidator, NgControlStatus, NgModel, MinLengthValidator, MatCheckbox, PatternValidator, ProfileComponent, MatButton], pipes: [DatePipe], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(EditPrincipalComponent, [{
        type: Component,
        args: [{
                selector: 'dst-sec-edit-principal',
                templateUrl: './edit-principal.component.html',
                styleUrls: ['./edit-principal.component.css']
            }]
    }], function () { return [{ type: PrincipalService }, { type: HateoasService }, { type: ActivatedRoute }, { type: UtilsService }, { type: UserNotifyService }]; }, { principalChange: [{
            type: Output
        }] }); })();

class ResetPasswordComponent {
    constructor(principalService, userNotify) {
        this.principalService = principalService;
        this.userNotify = userNotify;
        this.resetPasswordTitle = "Dimenticato la password?";
        this.resetPasswordSubtitle = "inserisci di seguito la tua mail" +
            " e ti invieremo una mail con le istruzioni per reimpostare la password";
        this.submitLabel = "INVIA RICHIESTA";
        this.form = new FormGroup({
            'email': new FormControl(null, [Validators.required, Validators.email])
        });
    }
    ngOnInit() {
    }
    resetPassword() {
        this.principalService.resetPasswordRequest(this.form.value.email).subscribe(result => {
            this.userNotify.notifySuccess("Richiesta di reset della password inviata");
        }, error => {
            console.error(error);
        });
    }
}
ResetPasswordComponent.ɵfac = function ResetPasswordComponent_Factory(t) { return new (t || ResetPasswordComponent)(ɵɵdirectiveInject(PrincipalService), ɵɵdirectiveInject(UserNotifyService)); };
ResetPasswordComponent.ɵcmp = ɵɵdefineComponent({ type: ResetPasswordComponent, selectors: [["dst-sec-reset-password"]], inputs: { resetPasswordTitle: "resetPasswordTitle", resetPasswordSubtitle: "resetPasswordSubtitle", submitLabel: "submitLabel" }, decls: 22, vars: 5, consts: [["id", "resetPasswordForm"], ["novalidate", "", 3, "formGroup"], [1, "row"], [1, "col"], ["matInput", "", "type", "email", "placeholder", "Inserisci la tua email", "name", "email", "formControlName", "email"], ["color", "primary", "mat-button", "", "mat-flat-button", "", 1, "login", 3, "disabled", "click"], [1, "float-right"], ["routerLink", "/security/login"]], template: function ResetPasswordComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "mat-card", 0);
        ɵɵelementStart(1, "mat-card-title");
        ɵɵtext(2);
        ɵɵelementEnd();
        ɵɵelementStart(3, "mat-card-subtitle");
        ɵɵtext(4);
        ɵɵelementEnd();
        ɵɵelementStart(5, "mat-card-content");
        ɵɵelementStart(6, "form", 1);
        ɵɵelementStart(7, "div", 2);
        ɵɵelementStart(8, "div", 3);
        ɵɵelementStart(9, "mat-form-field");
        ɵɵelementStart(10, "mat-label");
        ɵɵtext(11, "Email");
        ɵɵelementEnd();
        ɵɵelement(12, "input", 4);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(13, "div", 2);
        ɵɵelementStart(14, "div", 3);
        ɵɵelementStart(15, "button", 5);
        ɵɵlistener("click", function ResetPasswordComponent_Template_button_click_15_listener() { return ctx.resetPassword(); });
        ɵɵtext(16);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(17, "div", 3);
        ɵɵelementStart(18, "p", 6);
        ɵɵtext(19, " Torna alla ");
        ɵɵelementStart(20, "a", 7);
        ɵɵtext(21, "login");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(2);
        ɵɵtextInterpolate(ctx.resetPasswordTitle);
        ɵɵadvance(2);
        ɵɵtextInterpolate1("", ctx.resetPasswordSubtitle, " ");
        ɵɵadvance(2);
        ɵɵproperty("formGroup", ctx.form);
        ɵɵadvance(9);
        ɵɵproperty("disabled", ctx.form.invalid);
        ɵɵadvance(1);
        ɵɵtextInterpolate(ctx.submitLabel);
    } }, directives: [MatCard, MatCardTitle, MatCardSubtitle, MatCardContent, ɵangular_packages_forms_forms_y, NgControlStatusGroup, FormGroupDirective, MatFormField, MatLabel, MatInput, DefaultValueAccessor, NgControlStatus, FormControlName, MatButton, RouterLinkWithHref], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ResetPasswordComponent, [{
        type: Component,
        args: [{
                selector: 'dst-sec-reset-password',
                templateUrl: './reset-password.component.html',
                styleUrls: ['./reset-password.component.css']
            }]
    }], function () { return [{ type: PrincipalService }, { type: UserNotifyService }]; }, { resetPasswordTitle: [{
            type: Input
        }], resetPasswordSubtitle: [{
            type: Input
        }], submitLabel: [{
            type: Input
        }] }); })();

function PasswordResetComponent_p_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "p");
    ɵɵtext(1, "Le password non coincidono");
    ɵɵelementEnd();
} }
function PasswordResetComponent_mat_error_25_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-error");
    ɵɵtext(1, " Passwords do not match ");
    ɵɵelementEnd();
} }
const _c0$1 = function (a0) { return { "display": a0 }; };
class PasswordResetComponent {
    constructor(activatedRoute, formBuilder, principalService, utilService) {
        this.activatedRoute = activatedRoute;
        this.formBuilder = formBuilder;
        this.principalService = principalService;
        this.utilService = utilService;
        this.passwordResetTitle = "Reset Password";
        this.passwordResetSubtitle = "Inserisci la tua nuova password";
        this.passwordLabel = "Nuova password";
        this.passwordPlaceholder = "Inserisci la tua nuova password";
        this.repeatPasswordLabel = "Riperti la password";
        this.repeatPasswordPlaceholder = "Inserisci nuovamente la tua nuova password";
        this.submitLabel = "CONFERMA";
        this.successText = "La tua password è stata aggiornata vai alla <a href='/security/login'>login</a>";
        this.errorText = 'Non è stato possibile aggiornare la tua password contatta l\'amministratore';
        this.passwordRegex = Constants.DEFAULT_PASSWORD_REGEX;
        console.debug(utilService.getEnvProperty("passwordRegex"));
        if (utilService.getEnvProperty("passwordRegex")) {
            this.passwordRegex = utilService.getEnvProperty("passwordRegex");
        }
    }
    ngOnInit() {
        this.form = this.formBuilder.group({
            'password': [
                '', [
                    Validators.required, Validators.pattern(this.passwordRegex)
                ]
            ],
            'repeatPassword': [
                '',
                [
                    Validators.required, Validators.pattern(this.passwordRegex)
                ]
            ]
        }, { validator: this.passwordValidator });
        this.activatedRoute.queryParams.subscribe(result => {
            console.debug(result);
            this.token = result.resetToken;
        });
    }
    passwordValidator(group) {
        let pass = group.get('password').value;
        let confirm = group.get('repeatPassword').value;
        console.log("pass    ", pass);
        console.log("confirm    ", confirm);
        return pass === confirm ? null : { notSame: true };
    }
    resetPassword() {
        this.principalService.resetPassword(this.form.value.password, this.token).subscribe(result => {
            console.debug(result);
            this.res = this.successText;
            // this.principalService.getMyPrincipal().subscribe(
            //   result => {
            //     console.debug(result);
            //     this.principalService.setLogged(result);
            //   }
            // )
        }, error => {
            console.log(error.status);
            if (error.status == 404) {
                this.res = "richiesta non trovata, provare a fare una <a href='/security/resetPassword'>nuova richiesta di reset</a>";
            }
            else if (error.status == 400) {
                this.res = "Non è possibile resettare la password, contattare l'amministratore";
            }
            else {
                this.res = this.errorText;
            }
        });
    }
}
PasswordResetComponent.ɵfac = function PasswordResetComponent_Factory(t) { return new (t || PasswordResetComponent)(ɵɵdirectiveInject(ActivatedRoute), ɵɵdirectiveInject(FormBuilder), ɵɵdirectiveInject(PrincipalService), ɵɵdirectiveInject(UtilsService)); };
PasswordResetComponent.ɵcmp = ɵɵdefineComponent({ type: PasswordResetComponent, selectors: [["dst-sec-password-reset"]], inputs: { passwordResetTitle: "passwordResetTitle", passwordResetSubtitle: "passwordResetSubtitle", passwordLabel: "passwordLabel", passwordPlaceholder: "passwordPlaceholder", repeatPasswordLabel: "repeatPasswordLabel", repeatPasswordPlaceholder: "repeatPasswordPlaceholder", submitLabel: "submitLabel", successText: "successText", errorText: "errorText" }, decls: 30, vars: 19, consts: [[3, "ngStyle"], [3, "innerHTML"], ["id", "passwordReset", 3, "ngStyle"], [4, "ngIf"], [3, "formGroup"], [1, "row"], [1, "col"], ["matInput", "", "type", "password", "name", "password", "formControlName", "password", 3, "placeholder"], ["matInput", "", "type", "password", "name", "repeatPassword", "formControlName", "repeatPassword", 3, "placeholder"], ["type", "submit", "color", "primary", "mat-button", "", "mat-flat-button", "", 1, "login", 3, "disabled", "click"]], template: function PasswordResetComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "mat-card", 0);
        ɵɵelementStart(1, "mat-card-title");
        ɵɵtext(2);
        ɵɵelementEnd();
        ɵɵelementStart(3, "mat-card-content");
        ɵɵelement(4, "div", 1);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(5, "mat-card", 2);
        ɵɵelementStart(6, "mat-card-title");
        ɵɵtext(7);
        ɵɵelementEnd();
        ɵɵelementStart(8, "mat-card-subtitle");
        ɵɵtext(9);
        ɵɵtemplate(10, PasswordResetComponent_p_10_Template, 2, 0, "p", 3);
        ɵɵelementEnd();
        ɵɵelementStart(11, "mat-card-content");
        ɵɵelementStart(12, "form", 4);
        ɵɵelementStart(13, "div", 5);
        ɵɵelementStart(14, "div", 6);
        ɵɵelementStart(15, "mat-form-field");
        ɵɵelementStart(16, "mat-label");
        ɵɵtext(17);
        ɵɵelementEnd();
        ɵɵelement(18, "input", 7);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(19, "div", 5);
        ɵɵelementStart(20, "div", 6);
        ɵɵelementStart(21, "mat-form-field");
        ɵɵelementStart(22, "mat-label");
        ɵɵtext(23);
        ɵɵelementEnd();
        ɵɵelement(24, "input", 8);
        ɵɵelementEnd();
        ɵɵtemplate(25, PasswordResetComponent_mat_error_25_Template, 2, 0, "mat-error", 3);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(26, "div", 5);
        ɵɵelementStart(27, "div", 6);
        ɵɵelementStart(28, "button", 9);
        ɵɵlistener("click", function PasswordResetComponent_Template_button_click_28_listener() { return ctx.resetPassword(); });
        ɵɵtext(29);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("ngStyle", ɵɵpureFunction1(15, _c0$1, ctx.res ? "block" : "none"));
        ɵɵadvance(2);
        ɵɵtextInterpolate(ctx.passwordResetTitle);
        ɵɵadvance(2);
        ɵɵproperty("innerHTML", ctx.res, ɵɵsanitizeHtml);
        ɵɵadvance(1);
        ɵɵproperty("ngStyle", ɵɵpureFunction1(17, _c0$1, !ctx.res ? "block" : "none"));
        ɵɵadvance(2);
        ɵɵtextInterpolate(ctx.passwordResetTitle);
        ɵɵadvance(2);
        ɵɵtextInterpolate1("", ctx.passwordResetSubtitle, " ");
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.passMatch);
        ɵɵadvance(2);
        ɵɵproperty("formGroup", ctx.form);
        ɵɵadvance(5);
        ɵɵtextInterpolate(ctx.passwordLabel);
        ɵɵadvance(1);
        ɵɵpropertyInterpolate("placeholder", ctx.passwordPlaceholder);
        ɵɵadvance(5);
        ɵɵtextInterpolate(ctx.repeatPasswordLabel);
        ɵɵadvance(1);
        ɵɵpropertyInterpolate("placeholder", ctx.repeatPasswordPlaceholder);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.form.errors == null ? null : ctx.form.errors.notSame);
        ɵɵadvance(3);
        ɵɵproperty("disabled", ctx.form.invalid);
        ɵɵadvance(1);
        ɵɵtextInterpolate(ctx.submitLabel);
    } }, directives: [MatCard, NgStyle, MatCardTitle, MatCardContent, MatCardSubtitle, NgIf, ɵangular_packages_forms_forms_y, NgControlStatusGroup, FormGroupDirective, MatFormField, MatLabel, MatInput, DefaultValueAccessor, NgControlStatus, FormControlName, MatButton, MatError], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PasswordResetComponent, [{
        type: Component,
        args: [{
                selector: 'dst-sec-password-reset',
                templateUrl: './password-reset.component.html',
                styleUrls: ['./password-reset.component.css']
            }]
    }], function () { return [{ type: ActivatedRoute }, { type: FormBuilder }, { type: PrincipalService }, { type: UtilsService }]; }, { passwordResetTitle: [{
            type: Input
        }], passwordResetSubtitle: [{
            type: Input
        }], passwordLabel: [{
            type: Input
        }], passwordPlaceholder: [{
            type: Input
        }], repeatPasswordLabel: [{
            type: Input
        }], repeatPasswordPlaceholder: [{
            type: Input
        }], submitLabel: [{
            type: Input
        }], successText: [{
            type: Input
        }], errorText: [{
            type: Input
        }] }); })();

function ChangePasswordComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 10);
    ɵɵelementStart(1, "div", 3);
    ɵɵelementStart(2, "div", 11);
    ɵɵtext(3, " la password deve essere di 8 caratteri e contenere almeno una Maiuscola, un numero ed un simbolo ");
    ɵɵelementEnd();
    ɵɵelementStart(4, "div", 11);
    ɵɵtext(5, " Le password fornite non coincidono ");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵnextContext();
    const _r0 = ɵɵreference(5);
    const _r2 = ɵɵreference(19);
    const _r1 = ɵɵreference(12);
    ɵɵadvance(2);
    ɵɵproperty("hidden", _r0.form.valid);
    ɵɵadvance(2);
    ɵɵproperty("hidden", _r2.value == _r1.value);
} }
class ChangePasswordComponent {
    constructor(principalService, notifyUSer) {
        this.principalService = principalService;
        this.notifyUSer = notifyUSer;
        this.passwordRegex = Constants.DEFAULT_PASSWORD_REGEX;
    }
    ngOnInit() {
    }
    changePassword() {
        console.debug("change Password");
        this.principalService.changePassword(this.password).subscribe(result => {
            this.notifyUSer.notifySuccess("cambio password eseguito con successo");
        }, error => {
            this.notifyUSer.notifyError("errore nel cambio password");
        });
    }
}
ChangePasswordComponent.ɵfac = function ChangePasswordComponent_Factory(t) { return new (t || ChangePasswordComponent)(ɵɵdirectiveInject(PrincipalService), ɵɵdirectiveInject(UserNotifyService)); };
ChangePasswordComponent.ɵcmp = ɵɵdefineComponent({ type: ChangePasswordComponent, selectors: [["dst-sec-change-password"]], decls: 26, vars: 5, consts: [["id", "dst-securty-principal"], ["changePwForm", "ngForm"], [1, "row"], [1, "col"], ["matInput", "", "type", "password", "name", "password", "minlength", "8", "required", "", "placeholder", "password", 3, "pattern", "ngModel", "ngModelChange"], ["passwd", "ngModel"], ["matInput", "", "type", "password", "name", "repeatPassword", "required", "", "placeholder", "repeat password", 3, "ngModel", "ngModelChange"], ["repeatPwd", "ngModel"], ["class", "row", "class", "alert alert-danger", 4, "ngIf"], ["color", "primary", "mat-button", "", "mat-flat-button", "", 3, "disabled", "click"], [1, "alert", "alert-danger"], [3, "hidden"]], template: function ChangePasswordComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "mat-card", 0);
        ɵɵelementStart(1, "mat-card-title");
        ɵɵtext(2, "Aggiorna la password");
        ɵɵelementEnd();
        ɵɵelementStart(3, "mat-card-subtitle");
        ɵɵelementStart(4, "form", null, 1);
        ɵɵelementStart(6, "div", 2);
        ɵɵelementStart(7, "div", 3);
        ɵɵelementStart(8, "mat-form-field");
        ɵɵelementStart(9, "mat-label");
        ɵɵtext(10, "new password");
        ɵɵelementEnd();
        ɵɵelementStart(11, "input", 4, 5);
        ɵɵlistener("ngModelChange", function ChangePasswordComponent_Template_input_ngModelChange_11_listener($event) { return ctx.password = $event; });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(13, "div", 2);
        ɵɵelementStart(14, "div", 3);
        ɵɵelementStart(15, "mat-form-field");
        ɵɵelementStart(16, "mat-label");
        ɵɵtext(17, "repeat password");
        ɵɵelementEnd();
        ɵɵelementStart(18, "input", 6, 7);
        ɵɵlistener("ngModelChange", function ChangePasswordComponent_Template_input_ngModelChange_18_listener($event) { return ctx.repeatPw = $event; });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(20, ChangePasswordComponent_div_20_Template, 6, 2, "div", 8);
        ɵɵelementStart(21, "div", 2);
        ɵɵelementStart(22, "div", 3);
        ɵɵelementStart(23, "button", 9);
        ɵɵlistener("click", function ChangePasswordComponent_Template_button_click_23_listener() { return ctx.changePassword(); });
        ɵɵtext(24, "Conferma");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(25, "mat-card-content");
        ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵɵreference(5);
        const _r1 = ɵɵreference(12);
        const _r2 = ɵɵreference(19);
        ɵɵadvance(11);
        ɵɵpropertyInterpolate("pattern", ctx.passwordRegex);
        ɵɵproperty("ngModel", ctx.password);
        ɵɵadvance(7);
        ɵɵproperty("ngModel", ctx.repeatPw);
        ɵɵadvance(2);
        ɵɵproperty("ngIf", !_r0.form.valid || !(_r2.value == _r1.value));
        ɵɵadvance(3);
        ɵɵproperty("disabled", !_r0.form.valid || !(_r2.value == _r1.value));
    } }, directives: [MatCard, MatCardTitle, MatCardSubtitle, ɵangular_packages_forms_forms_y, NgControlStatusGroup, NgForm, MatFormField, MatLabel, MatInput, DefaultValueAccessor, MinLengthValidator, RequiredValidator, PatternValidator, NgControlStatus, NgModel, NgIf, MatButton, MatCardContent], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ChangePasswordComponent, [{
        type: Component,
        args: [{
                selector: 'dst-sec-change-password',
                templateUrl: './change-password.component.html',
                styleUrls: ['./change-password.component.css']
            }]
    }], function () { return [{ type: PrincipalService }, { type: UserNotifyService }]; }, null); })();

class SystemService extends HateoasService {
    constructor(http, utils) {
        super(http);
        this.utils = utils;
        this.myHttp = http;
    }
    list() {
        return this.get(this.utils.getEndPoint(SystemService.defaultUri) + "?projection=" + "systemWithSysRoles");
    }
}
SystemService.defaultUri = 'systemImpls';
SystemService.ɵfac = function SystemService_Factory(t) { return new (t || SystemService)(ɵɵinject(HttpClient), ɵɵinject(UtilsService)); };
SystemService.ɵprov = ɵɵdefineInjectable({ token: SystemService, factory: SystemService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(SystemService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HttpClient }, { type: UtilsService }]; }, null); })();

class System extends Hateoas {
}

class SysRoleService extends HateoasService {
    constructor(http, utils) {
        super(http);
        this.utils = utils;
        this.myHttp = http;
    }
}
SysRoleService.defaultUri = 'sysRoleImpls';
SysRoleService.ɵfac = function SysRoleService_Factory(t) { return new (t || SysRoleService)(ɵɵinject(HttpClient), ɵɵinject(UtilsService)); };
SysRoleService.ɵprov = ɵɵdefineInjectable({ token: SysRoleService, factory: SysRoleService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(SysRoleService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HttpClient }, { type: UtilsService }]; }, null); })();

class SysRole extends Hateoas {
}

function SysRolesComponent_mat_list_item_24_button_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "button", 5);
    ɵɵelementStart(1, "mat-icon");
    ɵɵtext(2, "edit");
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function SysRolesComponent_mat_list_item_24_button_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "button", 11);
    ɵɵelementStart(1, "mat-icon");
    ɵɵtext(2, "delete");
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function SysRolesComponent_mat_list_item_24_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-list-item");
    ɵɵtext(1);
    ɵɵelementStart(2, "span", 8);
    ɵɵtemplate(3, SysRolesComponent_mat_list_item_24_button_3_Template, 3, 0, "button", 9);
    ɵɵtemplate(4, SysRolesComponent_mat_list_item_24_button_4_Template, 3, 0, "button", 10);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const role_r1 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", role_r1.fullName, " ");
    ɵɵadvance(2);
    ɵɵproperty("ngIf", !role_r1.readOnly);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !role_r1.readOnly);
} }
class SysRolesComponent {
    constructor(sysRoleService, utils, userNotify) {
        this.sysRoleService = sysRoleService;
        this.utils = utils;
        this.userNotify = userNotify;
        this.sysRole = new SysRole();
    }
    ngOnInit() {
        this.list();
    }
    list() {
        if (!this._system._links)
            return;
        this.sysRoleService.get(this._system._links.sysRoles.href).subscribe(result => {
            let emb = new HateoasEmbedded();
            emb.init(result);
            this.sysRoles = emb.getObects(SysRoleService.defaultUri);
            // if (this.sysRoles.length > 0) {
            //   this.sysRole = this.sysRoles[0];
            // }
        }, error => {
            this.userNotify.notifySuccess("errore nel caricamento dei sistemi");
        });
    }
    set system(system) {
        this._system = system;
        this.list();
    }
    get system() {
        return this._system;
    }
    save() {
        console.debug("SAVE????");
        console.debug(this.sysRole);
    }
}
SysRolesComponent.ɵfac = function SysRolesComponent_Factory(t) { return new (t || SysRolesComponent)(ɵɵdirectiveInject(SysRoleService), ɵɵdirectiveInject(UtilsService), ɵɵdirectiveInject(UserNotifyService)); };
SysRolesComponent.ɵcmp = ɵɵdefineComponent({ type: SysRolesComponent, selectors: [["dst-sec-sys-roles"]], inputs: { system: "system" }, decls: 25, vars: 5, consts: [["id", "dst-securty-system"], [1, "row"], [1, "col"], ["matInput", "", "type", "text", "name", "sysRole", "required", "", "minlength", "4", "placeholder", "nome ruolo", 3, "ngModel", "disabled", "ngModelChange"], [1, "col-2"], ["mat-icon-button", "", "color", "primary"], ["mat-icon-button", "", "color", "primary", 3, "click"], [4, "ngFor", "ngForOf"], ["my-mat-list-item-span", ""], ["mat-icon-button", "", "color", "primary", 4, "ngIf"], ["mat-icon-button", "", "color", "warn", 4, "ngIf"], ["mat-icon-button", "", "color", "warn"]], template: function SysRolesComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "mat-card", 0);
        ɵɵelementStart(1, "mat-card-title");
        ɵɵtext(2);
        ɵɵelementEnd();
        ɵɵelementStart(3, "mat-card-subtitle");
        ɵɵtext(4, " Gestione dei dati anagrafici dei sistemi software ");
        ɵɵelementEnd();
        ɵɵelementStart(5, "mat-card-content");
        ɵɵelementStart(6, "div", 1);
        ɵɵelementStart(7, "div", 2);
        ɵɵelementStart(8, "mat-form-field");
        ɵɵelementStart(9, "mat-label");
        ɵɵtext(10, "Nome Ruolo");
        ɵɵelementEnd();
        ɵɵelementStart(11, "input", 3);
        ɵɵlistener("ngModelChange", function SysRolesComponent_Template_input_ngModelChange_11_listener($event) { return ctx.sysRole.name = $event; });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(12, "div", 2);
        ɵɵtext(13);
        ɵɵelementEnd();
        ɵɵelementStart(14, "div", 4);
        ɵɵelementStart(15, "button", 5);
        ɵɵelementStart(16, "mat-icon");
        ɵɵtext(17, "add_box");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(18, "button", 6);
        ɵɵlistener("click", function SysRolesComponent_Template_button_click_18_listener() { return ctx.save(); });
        ɵɵelementStart(19, "mat-icon");
        ɵɵtext(20, "save");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(21, "div", 1);
        ɵɵelementStart(22, "div", 2);
        ɵɵelementStart(23, "mat-list");
        ɵɵtemplate(24, SysRolesComponent_mat_list_item_24_Template, 5, 3, "mat-list-item", 7);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(2);
        ɵɵtextInterpolate1("Gestione Ruoli Applicativi del Sistema ", ctx._system.nome, " ");
        ɵɵadvance(9);
        ɵɵproperty("ngModel", ctx.sysRole.name)("disabled", ctx.sysRole && ctx.sysRole.readOnly);
        ɵɵadvance(2);
        ɵɵtextInterpolate(ctx.sysRole.fullName);
        ɵɵadvance(11);
        ɵɵproperty("ngForOf", ctx.sysRoles);
    } }, directives: [MatCard, MatCardTitle, MatCardSubtitle, MatCardContent, MatFormField, MatLabel, MatInput, DefaultValueAccessor, RequiredValidator, MinLengthValidator, NgControlStatus, NgModel, MatButton, MatIcon, MatList, NgForOf, MatListItem, NgIf], styles: [".mat-list-item[_ngcontent-%COMP%]:hover{background-color:hsla(0,0%,85.5%,.4);font-weight:120}span[my-mat-list-item-span][_ngcontent-%COMP%]{margin-left:auto}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(SysRolesComponent, [{
        type: Component,
        args: [{
                selector: 'dst-sec-sys-roles',
                templateUrl: './sys-roles.component.html',
                styleUrls: ['./sys-roles.component.css']
            }]
    }], function () { return [{ type: SysRoleService }, { type: UtilsService }, { type: UserNotifyService }]; }, { system: [{
            type: Input
        }] }); })();

function SystemsComponent_mat_option_13_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-option", 12);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const sys_r3 = ctx.$implicit;
    ɵɵproperty("value", sys_r3);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", sys_r3.nome, " ");
} }
function SystemsComponent_dst_sec_sys_roles_36_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "dst-sec-sys-roles", 13);
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵproperty("system", ctx_r2.system);
} }
class SystemsComponent {
    constructor(systemService, utils, userNotify) {
        this.systemService = systemService;
        this.utils = utils;
        this.userNotify = userNotify;
    }
    ngOnInit() {
        this.list();
    }
    list() {
        this.systemService.get(this.utils.getEndPoint(SystemService.defaultUri)).subscribe(result => {
            let emb = new HateoasEmbedded();
            emb.init(result);
            this.systems = emb.getObects(SystemService.defaultUri);
            if (this.systems.length > 0) {
                this.system = this.systems[0];
            }
        }, error => {
            this.userNotify.notifySuccess("errore nel caricamento dei sistemi");
        });
    }
    systemSelectHandler(event) {
        console.debug(event);
    }
    newSystem() {
        this.system = new System();
        this.system.readOnly = false;
    }
    saveSystem() {
        this.systemService.createObject(this.utils.getEndPoint(SystemService.defaultUri), this.system).subscribe(result => {
            this.userNotify.notifySuccess("sistema salvato co successo");
            this.list();
        }, error => {
            this.userNotify.notifyError("errore nel salvataggio del sistema");
        });
    }
}
SystemsComponent.ɵfac = function SystemsComponent_Factory(t) { return new (t || SystemsComponent)(ɵɵdirectiveInject(SystemService), ɵɵdirectiveInject(UtilsService), ɵɵdirectiveInject(UserNotifyService)); };
SystemsComponent.ɵcmp = ɵɵdefineComponent({ type: SystemsComponent, selectors: [["dst-sec-systems"]], decls: 37, vars: 7, consts: [[1, "row"], [1, "col"], ["id", "dst-securty-system"], ["mat-mini-fab", "", "mat-fab", "", "color", "primary", 3, "click"], [1, "inputSelect"], [3, "value", "selectionChange", "valueChange"], [3, "value", 4, "ngFor", "ngForOf"], ["systemForm", "ngForm"], ["matInput", "", "type", "text", "name", "system_nome", "required", "", "minlength", "4", "placeholder", "nome sistema", 3, "ngModel", "disabled", "ngModelChange"], ["matInput", "", "type", "text", "name", "system_description", "required", "", "minlength", "4", "placeholder", "descrizione sistema", 3, "ngModel", "ngModelChange"], ["type", "submit", "color", "primary", "mat-button", "", "mat-flat-button", "", 3, "disabled", "click"], [3, "system", 4, "ngIf"], [3, "value"], [3, "system"]], template: function SystemsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "mat-card", 2);
        ɵɵelementStart(3, "mat-card-title");
        ɵɵtext(4, "Gestione Anagrafica Sistemi ");
        ɵɵelementStart(5, "button", 3);
        ɵɵlistener("click", function SystemsComponent_Template_button_click_5_listener() { return ctx.newSystem(); });
        ɵɵelementStart(6, "mat-icon");
        ɵɵtext(7, "add");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(8, "mat-card-subtitle");
        ɵɵtext(9, " Gestione dei dati anagrafici dei sistemi software ");
        ɵɵelementEnd();
        ɵɵelementStart(10, "mat-card-content");
        ɵɵelementStart(11, "mat-form-field", 4);
        ɵɵelementStart(12, "mat-select", 5);
        ɵɵlistener("selectionChange", function SystemsComponent_Template_mat_select_selectionChange_12_listener($event) { return ctx.systemSelectHandler($event); })("valueChange", function SystemsComponent_Template_mat_select_valueChange_12_listener($event) { return ctx.system = $event; });
        ɵɵtemplate(13, SystemsComponent_mat_option_13_Template, 2, 2, "mat-option", 6);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(14, "form", null, 7);
        ɵɵelementStart(16, "div", 0);
        ɵɵelementStart(17, "div", 1);
        ɵɵelementStart(18, "mat-form-field");
        ɵɵelementStart(19, "mat-label");
        ɵɵtext(20, "Nome Sistema");
        ɵɵelementEnd();
        ɵɵelementStart(21, "input", 8);
        ɵɵlistener("ngModelChange", function SystemsComponent_Template_input_ngModelChange_21_listener($event) { return ctx.system.nome = $event; });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(22, "div", 0);
        ɵɵelementStart(23, "div", 1);
        ɵɵelementStart(24, "mat-form-field");
        ɵɵelementStart(25, "mat-label");
        ɵɵtext(26, "Descrizione");
        ɵɵelementEnd();
        ɵɵelementStart(27, "textarea", 9);
        ɵɵlistener("ngModelChange", function SystemsComponent_Template_textarea_ngModelChange_27_listener($event) { return ctx.system.description = $event; });
        ɵɵtext(28, " ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(29, "div", 0);
        ɵɵelementStart(30, "div", 1);
        ɵɵelementStart(31, "button", 10);
        ɵɵlistener("click", function SystemsComponent_Template_button_click_31_listener() { return ctx.saveSystem(); });
        ɵɵelementStart(32, "mat-icon");
        ɵɵtext(33, "save");
        ɵɵelementEnd();
        ɵɵtext(34, "Conferma");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(35, "div", 1);
        ɵɵtemplate(36, SystemsComponent_dst_sec_sys_roles_36_Template, 1, 1, "dst-sec-sys-roles", 11);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = ɵɵreference(15);
        ɵɵadvance(12);
        ɵɵproperty("value", ctx.system);
        ɵɵadvance(1);
        ɵɵproperty("ngForOf", ctx.systems);
        ɵɵadvance(8);
        ɵɵproperty("ngModel", ctx.system.nome)("disabled", ctx.system.readOnly);
        ɵɵadvance(6);
        ɵɵproperty("ngModel", ctx.system.description);
        ɵɵadvance(4);
        ɵɵproperty("disabled", !_r1.form.valid);
        ɵɵadvance(5);
        ɵɵproperty("ngIf", ctx.system._links && ctx.system._links.sysRoles);
    } }, directives: [MatCard, MatCardTitle, MatButton, MatIcon, MatCardSubtitle, MatCardContent, MatFormField, MatSelect, NgForOf, ɵangular_packages_forms_forms_y, NgControlStatusGroup, NgForm, MatLabel, MatInput, DefaultValueAccessor, RequiredValidator, MinLengthValidator, NgControlStatus, NgModel, NgIf, MatOption, SysRolesComponent], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(SystemsComponent, [{
        type: Component,
        args: [{
                selector: 'dst-sec-systems',
                templateUrl: './systems.component.html',
                styleUrls: ['./systems.component.css']
            }]
    }], function () { return [{ type: SystemService }, { type: UtilsService }, { type: UserNotifyService }]; }, null); })();

class Page {
    constructor(values = {}) {
        Object.assign(this, values);
    }
    getPageQueryParams() {
        return `size=${this.size}&page=${this.number}`;
    }
    nextPage() {
        if (this.number < this.totalPages)
            this.number++;
    }
    hasMoreResults() {
        return this.number < this.totalPages;
    }
    setPaginatorEvent(pagEvent) {
        this.size = pagEvent.pageSize;
        this.number = pagEvent.pageIndex;
    }
}

const _c0$2 = ["profileSelList"];
function ProfileSelectListComponent_mat_list_option_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-list-option", 4);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const p_r2 = ctx.$implicit;
    ɵɵproperty("value", p_r2);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", p_r2.name, " ");
} }
const _c1$1 = function () { return [5, 10, 25, 100]; };
class ProfileSelectListComponent {
    constructor(profileService) {
        this.profileService = profileService;
        this.page = new Page({ size: 5, number: 0 });
        this.profileSelected = new EventEmitter();
        this.profiles = new Array();
    }
    ngOnInit() {
        this.list();
    }
    list() {
        console.log("AO AO AO sto a lista!!!");
        this.profileService.list(this.page).subscribe(results => {
            this.profiles = results._embedded.profileImpls;
            this.page = new Page(results.page);
            console.log(results);
        });
    }
    onProfileSelected(event) {
        console.log(event);
        let profile = new Profile(event.option.value);
        this.profileSelected.next(profile);
    }
    newProfile() {
        this.profileSelected.next(new Profile());
        this.profileSelList.deselectAll();
    }
    pageChanged($pageEvent) {
        console.log($pageEvent);
        // this.page= new Page(this.page);
        this.page.setPaginatorEvent($pageEvent);
        this.list();
    }
}
ProfileSelectListComponent.ɵfac = function ProfileSelectListComponent_Factory(t) { return new (t || ProfileSelectListComponent)(ɵɵdirectiveInject(ProfileService)); };
ProfileSelectListComponent.ɵcmp = ɵɵdefineComponent({ type: ProfileSelectListComponent, selectors: [["dst-sec-profile-select-list"]], viewQuery: function ProfileSelectListComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$2, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.profileSelList = _t.first);
    } }, inputs: { page: "page" }, outputs: { profileSelected: "profileSelected" }, decls: 5, vars: 5, consts: [["multiple", "false", 3, "selectionChange"], ["profileSelList", ""], [3, "value", 4, "ngFor", "ngForOf"], [3, "length", "pageSize", "pageSizeOptions", "page"], [3, "value"]], template: function ProfileSelectListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "mat-selection-list", 0, 1);
        ɵɵlistener("selectionChange", function ProfileSelectListComponent_Template_mat_selection_list_selectionChange_0_listener($event) { return ctx.onProfileSelected($event); });
        ɵɵtemplate(2, ProfileSelectListComponent_mat_list_option_2_Template, 2, 2, "mat-list-option", 2);
        ɵɵelementEnd();
        ɵɵelementStart(3, "div");
        ɵɵelementStart(4, "mat-paginator", 3);
        ɵɵlistener("page", function ProfileSelectListComponent_Template_mat_paginator_page_4_listener($event) { return ctx.pageChanged($event); });
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(2);
        ɵɵproperty("ngForOf", ctx.profiles);
        ɵɵadvance(2);
        ɵɵproperty("length", ctx.page.totalElements)("pageSize", ctx.page.size)("pageSizeOptions", ɵɵpureFunction0(4, _c1$1));
    } }, directives: [MatSelectionList, NgForOf, MatPaginator, MatListOption], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ProfileSelectListComponent, [{
        type: Component,
        args: [{
                selector: 'dst-sec-profile-select-list',
                templateUrl: './profile-select-list.component.html',
                styleUrls: ['./profile-select-list.component.css']
            }]
    }], function () { return [{ type: ProfileService }]; }, { page: [{
            type: Input
        }], profileSelected: [{
            type: Output
        }], profileSelList: [{
            type: ViewChild,
            args: ['profileSelList']
        }] }); })();

function ConfirmDialogComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 2);
    ɵɵelementStart(1, "div", 9);
    ɵɵelementStart(2, "div", 10);
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelementStart(4, "div", 11);
    ɵɵtext(5);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(3);
    ɵɵtextInterpolate1(" ", ctx_r0.data.dato.label, " ");
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" ", ctx_r0.data.dato.value, " ");
} }
class ConfirmDialogComponent {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.text = this.data.text;
        this.title = this.data.title;
    }
    closeDialog() {
        this.dialogRef.close();
    }
    conferma() {
        this.dialogRef.close(true);
    }
}
ConfirmDialogComponent.ɵfac = function ConfirmDialogComponent_Factory(t) { return new (t || ConfirmDialogComponent)(ɵɵdirectiveInject(MatDialogRef), ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
ConfirmDialogComponent.ɵcmp = ɵɵdefineComponent({ type: ConfirmDialogComponent, selectors: [["dst-sec-confirm-dialog"]], decls: 15, vars: 3, consts: [[1, "row"], [1, "col-12", "text-center"], [1, "row", "my-4"], ["class", "row my-4", 4, "ngIf"], [1, "row", "text-center"], [1, "col-5", "offset-1"], ["mat-button", "", "color", "primary", 3, "click"], [1, "col-5"], ["mat-button", "", "color", "warn", 3, "click"], [1, "col-12"], [1, "testoModali", "font-weight-bold"], [1, "testoModali"]], template: function ConfirmDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "h5");
        ɵɵtext(3);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(4, "div", 2);
        ɵɵelementStart(5, "div", 1);
        ɵɵtext(6);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(7, ConfirmDialogComponent_div_7_Template, 6, 2, "div", 3);
        ɵɵelementStart(8, "div", 4);
        ɵɵelementStart(9, "div", 5);
        ɵɵelementStart(10, "button", 6);
        ɵɵlistener("click", function ConfirmDialogComponent_Template_button_click_10_listener() { return ctx.closeDialog(); });
        ɵɵtext(11, " Annulla ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(12, "div", 7);
        ɵɵelementStart(13, "button", 8);
        ɵɵlistener("click", function ConfirmDialogComponent_Template_button_click_13_listener() { return ctx.conferma(); });
        ɵɵtext(14, " Conferma ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(3);
        ɵɵtextInterpolate1(" ", ctx.title, " ");
        ɵɵadvance(3);
        ɵɵtextInterpolate1(" ", ctx.text, " ");
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.data.dato);
    } }, directives: [NgIf, MatButton], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ConfirmDialogComponent, [{
        type: Component,
        args: [{
                selector: 'dst-sec-confirm-dialog',
                templateUrl: './confirm-dialog.component.html',
                styleUrls: ['./confirm-dialog.component.css']
            }]
    }], function () { return [{ type: MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, null); })();

function ProfileFormComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "div", 2);
    ɵɵelementStart(2, "div", 3);
    ɵɵelementStart(3, "form", null, 8);
    ɵɵelementStart(5, "div", 2);
    ɵɵelementStart(6, "div", 3);
    ɵɵelementStart(7, "mat-form-field");
    ɵɵelementStart(8, "mat-label");
    ɵɵtext(9, "Name");
    ɵɵelementEnd();
    ɵɵelementStart(10, "input", 9);
    ɵɵlistener("ngModelChange", function ProfileFormComponent_div_0_Template_input_ngModelChange_10_listener($event) { ɵɵrestoreView(_r4); const ctx_r3 = ɵɵnextContext(); return ctx_r3.profile.name = $event; });
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(11, "div", 2);
    ɵɵelementStart(12, "div", 3);
    ɵɵelementStart(13, "mat-form-field");
    ɵɵelementStart(14, "mat-label");
    ɵɵtext(15, "Description");
    ɵɵelementEnd();
    ɵɵelementStart(16, "input", 10);
    ɵɵlistener("ngModelChange", function ProfileFormComponent_div_0_Template_input_ngModelChange_16_listener($event) { ɵɵrestoreView(_r4); const ctx_r5 = ɵɵnextContext(); return ctx_r5.profile.description = $event; });
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(10);
    ɵɵproperty("ngModel", ctx_r0.profile.name);
    ɵɵadvance(6);
    ɵɵproperty("ngModel", ctx_r0.profile.description);
} }
function ProfileFormComponent_div_1_mat_option_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-option", 18);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const system_r9 = ctx.$implicit;
    ɵɵproperty("value", system_r9);
    ɵɵadvance(1);
    ɵɵtextInterpolate(system_r9.nome);
} }
function ProfileFormComponent_div_1_mat_list_option_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-list-option", 19);
    ɵɵtext(1);
    ɵɵelementStart(2, "span", 20);
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const sysRole_r10 = ctx.$implicit;
    const ctx_r8 = ɵɵnextContext(2);
    ɵɵproperty("value", sysRole_r10)("selected", ctx_r8.mySysRoleCheckArray[sysRole_r10.fullName] === true);
    ɵɵadvance(1);
    ɵɵtextInterpolate1("", sysRole_r10.fullName, " ");
    ɵɵadvance(2);
    ɵɵtextInterpolate(sysRole_r10.description);
} }
function ProfileFormComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 11);
    ɵɵelementStart(1, "div", 2);
    ɵɵelementStart(2, "div", 3);
    ɵɵelementStart(3, "mat-select", 12);
    ɵɵlistener("valueChange", function ProfileFormComponent_div_1_Template_mat_select_valueChange_3_listener($event) { ɵɵrestoreView(_r12); const ctx_r11 = ɵɵnextContext(); return ctx_r11.selSystem = $event; })("selectionChange", function ProfileFormComponent_div_1_Template_mat_select_selectionChange_3_listener($event) { ɵɵrestoreView(_r12); const _r7 = ɵɵreference(8); const ctx_r13 = ɵɵnextContext(); return ctx_r13.onSystemChange($event, _r7); });
    ɵɵtemplate(4, ProfileFormComponent_div_1_mat_option_4_Template, 2, 2, "mat-option", 13);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(5, "div", 14);
    ɵɵelementStart(6, "div", 3);
    ɵɵelementStart(7, "mat-selection-list", 15, 16);
    ɵɵlistener("selectionChange", function ProfileFormComponent_div_1_Template_mat_selection_list_selectionChange_7_listener($event) { ɵɵrestoreView(_r12); const ctx_r14 = ɵɵnextContext(); return ctx_r14.toggleRole($event); });
    ɵɵtemplate(9, ProfileFormComponent_div_1_mat_list_option_9_Template, 4, 4, "mat-list-option", 17);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(3);
    ɵɵproperty("value", ctx_r1.selSystem);
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ctx_r1.systems);
    ɵɵadvance(5);
    ɵɵproperty("ngForOf", ctx_r1.selSystem == null ? null : ctx_r1.selSystem.sysRoles);
} }
class ProfileFormComponent {
    constructor(systemService, profileService, utils, dialog) {
        this.systemService = systemService;
        this.profileService = profileService;
        this.utils = utils;
        this.dialog = dialog;
        this.profile = new Profile();
        this.childChanged = new EventEmitter();
        this.systems = new Array();
        this.profileUsers = 1;
    }
    ngOnChanges(changes) {
        console.log(this.profile);
        this.mySysRoleCheckArray = [];
        this.refreshProfileSysRoles();
        this.countProfileUsers();
        //  this.loadProfileSysRoles();
    }
    countProfileUsers() {
        if (this.profile._links) {
            this.profileService.countProfileUsers(this.profile).subscribe(result => { this.profileUsers = result; console.log(result); });
        }
        else {
            this, this.profileUsers = 0;
        }
    }
    ngOnInit() {
        this.loadSystems();
    }
    loadSystems() {
        this.systemService.list().subscribe(results => {
            var _a;
            this.systems = results._embedded.systemImpls;
            if (((_a = this.systems) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                this.selSystem = this.systems[0];
                this.systems.forEach(element => {
                    this.loadSystemRoles(element);
                });
            }
            ;
        });
    }
    loadSystemRoles(system) {
        this.systemService.get(system._links.sysRoles.href).subscribe(results => {
            system.sysRoles = results._embedded.sysRoleImpls;
            console.log(system);
        });
    }
    loadProfileSysRoles() {
        if (this.profile && this.profile._links) {
            this.systemService.get(this.profile._links.sysRoles.href).subscribe(results => {
                this.profile.sysRoles = results._embedded.sysRoleImpls;
                this.refreshProfileSysRoles();
            });
        }
    }
    onSystemChange($event, selList) {
        console.log($event);
        console.log(selList);
        // this.selList=selList;
        selList.deselectAll();
        this.refreshProfileSysRoles();
    }
    refreshProfileSysRoles() {
        this.mySysRoleCheckArray = [];
        // rinfresco l'array dei sysroles sele<ionati solo se esistono 
        if (this.profile.sysRoles) {
            this.profile.sysRoles.forEach(element => {
                this.mySysRoleCheckArray[element.fullName] = true;
            });
        }
    }
    undo() {
        if (this.profile._links)
            this.systemService.get(this.profile._links.self.href + "?projection=profileWithSysRoles").subscribe(result => {
                this.profile = new Profile(result);
                this.loadSystems();
                this.refreshProfileSysRoles();
            });
        else
            this.profile = new Profile({});
    }
    toggleRole($event) {
        console.log($event);
        let option = $event.option;
        let sysRole = new SysRole(option.value);
        if (option.selected) {
            this.systemService.addElementToCollection(this.profile._links.sysRoles.href, sysRole._links.self.href).subscribe(result => {
                console.log(result);
                this.mySysRoleCheckArray[sysRole.fullName] = true;
                this.profile.sysRoles.push(sysRole);
            });
        }
        else {
            this.systemService.removeElementFromCollection(`${this.profile._links.sysRoles.href}/${sysRole.getIdBySelf()}`).subscribe(result => {
                console.log(result);
                this.mySysRoleCheckArray[sysRole.fullName] = false;
                this.loadProfileSysRoles();
            });
        }
    }
    save() {
        let createNewObject = this.profile._links ? false : true;
        this.profileService.save(this.profile).subscribe(result => {
            this.profile = new Profile(result);
            this.loadProfileSysRoles();
            if (createNewObject)
                this.changed();
        });
    }
    delete() {
        const confirmDialog = this.dialog.open(ConfirmDialogComponent, { data: { title: "Conferma Cancellazione Profilo", text: "sei sicuro di coler cancellare il profilo corrente" } });
        confirmDialog.afterClosed().subscribe(result => {
            if (result === true && this.profile._links) {
                this.profileService.deleteObject(this.profile._links.self.href).subscribe(result => {
                    console.log("ti ho fatto secco!!!");
                    this.profile = new Profile();
                    this.changed();
                });
            }
        });
    }
    canDelete() {
        console.log(this.profile.name, this.profile.readOnly);
        return !(this.profile._links && this.profileUsers < 1) && this.profile.readOnly;
    }
    changed() {
        console.log("sto a emittà!!!");
        this.childChanged.emit(true);
    }
}
ProfileFormComponent.ɵfac = function ProfileFormComponent_Factory(t) { return new (t || ProfileFormComponent)(ɵɵdirectiveInject(SystemService), ɵɵdirectiveInject(ProfileService), ɵɵdirectiveInject(UtilsService), ɵɵdirectiveInject(MatDialog)); };
ProfileFormComponent.ɵcmp = ɵɵdefineComponent({ type: ProfileFormComponent, selectors: [["dst-sec-profile-form"]], inputs: { profile: "profile" }, outputs: { childChanged: "childChanged" }, features: [ɵɵNgOnChangesFeature], decls: 18, vars: 3, consts: [[4, "ngIf"], ["class", "roleSelection", 4, "ngIf"], [1, "row"], [1, "col"], ["mat-button", "", 3, "click"], ["aria-hidden", "false", "aria-label", "Example home icon"], ["mat-button", "", "color", "warn", 3, "disabled", "click"], ["color", "primary", "mat-button", "", 3, "click"], ["profileForm", "ngForm"], ["matInput", "", "type", "text", "name", "name", "required", "", "placeholder", "profile name", 3, "ngModel", "ngModelChange"], ["matInput", "", "type", "text", "name", "description", "placeholder", "decrizione profilo", 3, "ngModel", "ngModelChange"], [1, "roleSelection"], [3, "value", "valueChange", "selectionChange"], [3, "value", 4, "ngFor", "ngForOf"], [1, "sysRolesList"], [3, "selectionChange"], ["selectedSystemsOpts", ""], [3, "value", "selected", 4, "ngFor", "ngForOf"], [3, "value"], [3, "value", "selected"], [1, "description"]], template: function ProfileFormComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, ProfileFormComponent_div_0_Template, 17, 2, "div", 0);
        ɵɵtemplate(1, ProfileFormComponent_div_1_Template, 10, 3, "div", 1);
        ɵɵelementStart(2, "div", 2);
        ɵɵelementStart(3, "div", 3);
        ɵɵelementStart(4, "button", 4);
        ɵɵlistener("click", function ProfileFormComponent_Template_button_click_4_listener() { return ctx.undo(); });
        ɵɵelementStart(5, "mat-icon", 5);
        ɵɵtext(6, "undo");
        ɵɵelementEnd();
        ɵɵtext(7, " Annulla ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(8, "div", 3);
        ɵɵelementStart(9, "button", 6);
        ɵɵlistener("click", function ProfileFormComponent_Template_button_click_9_listener() { return ctx.delete(); });
        ɵɵelementStart(10, "mat-icon", 5);
        ɵɵtext(11, "delete");
        ɵɵelementEnd();
        ɵɵtext(12, " Elimina ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(13, "div", 3);
        ɵɵelementStart(14, "button", 7);
        ɵɵlistener("click", function ProfileFormComponent_Template_button_click_14_listener() { return ctx.save(); });
        ɵɵelementStart(15, "mat-icon", 5);
        ɵɵtext(16, "save");
        ɵɵelementEnd();
        ɵɵtext(17, " Salva ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.profile);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.profile._links);
        ɵɵadvance(8);
        ɵɵproperty("disabled", ctx.canDelete());
    } }, directives: [NgIf, MatButton, MatIcon, ɵangular_packages_forms_forms_y, NgControlStatusGroup, NgForm, MatFormField, MatLabel, MatInput, DefaultValueAccessor, RequiredValidator, NgControlStatus, NgModel, MatSelect, NgForOf, MatSelectionList, MatOption, MatListOption], styles: ["div.mat-list-text[_ngcontent-%COMP%]{text-align:left}div.sysRolesList[_ngcontent-%COMP%]{height:100%;text-align:left}.description[_ngcontent-%COMP%]{font-size:x-small}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ProfileFormComponent, [{
        type: Component,
        args: [{
                selector: 'dst-sec-profile-form',
                templateUrl: './profile-form.component.html',
                styleUrls: ['./profile-form.component.css']
            }]
    }], function () { return [{ type: SystemService }, { type: ProfileService }, { type: UtilsService }, { type: MatDialog }]; }, { profile: [{
            type: Input
        }], childChanged: [{
            type: Output
        }] }); })();

class ProfilesComponent {
    constructor(profileService) {
        this.profileService = profileService;
        this.profiles = new Array();
        this.profile = new Profile();
        this.page = new Page({ size: 5, number: 0 });
    }
    ngOnInit() {
        this.list();
    }
    list() {
        console.log("AO AO AO sto a lista!!!");
        this.profileService.list(this.page).subscribe(results => {
            this.profiles = results._embedded.profileImpls;
            this.page = new Page(results.page);
            console.log(results);
        });
    }
    onProfileSelected(profile) {
        console.log(profile);
        this.profile = new Profile(profile);
    }
    newProfile(profileSelList) {
        this.profile = new Profile();
        profileSelList.deselectAll();
    }
    pageChanged($pageEvent) {
        console.log($pageEvent);
        // this.page= new Page(this.page);
        this.page.setPaginatorEvent($pageEvent);
        this.list();
    }
}
ProfilesComponent.ɵfac = function ProfilesComponent_Factory(t) { return new (t || ProfilesComponent)(ɵɵdirectiveInject(ProfileService)); };
ProfilesComponent.ɵcmp = ɵɵdefineComponent({ type: ProfilesComponent, selectors: [["dst-sec-profiles"]], decls: 13, vars: 1, consts: [[1, "row"], [1, "col"], ["mat-button", "", 3, "click"], ["aria-hidden", "false", "aria-label", "Example home icon"], [3, "profileSelected"], ["profSelList", ""], [3, "profile", "childChanged"]], template: function ProfilesComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = ɵɵgetCurrentView();
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "mat-card");
        ɵɵelementStart(3, "mat-card-title");
        ɵɵelementStart(4, "button", 2);
        ɵɵlistener("click", function ProfilesComponent_Template_button_click_4_listener() { ɵɵrestoreView(_r1); const _r0 = ɵɵreference(9); return _r0.newProfile(); });
        ɵɵelementStart(5, "mat-icon", 3);
        ɵɵtext(6, "add_box");
        ɵɵelementEnd();
        ɵɵtext(7, " Nuovo profilo ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(8, "dst-sec-profile-select-list", 4, 5);
        ɵɵlistener("profileSelected", function ProfilesComponent_Template_dst_sec_profile_select_list_profileSelected_8_listener($event) { return ctx.onProfileSelected($event); });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(10, "div", 1);
        ɵɵelementStart(11, "mat-card");
        ɵɵelementStart(12, "dst-sec-profile-form", 6);
        ɵɵlistener("childChanged", function ProfilesComponent_Template_dst_sec_profile_form_childChanged_12_listener() { ɵɵrestoreView(_r1); const _r0 = ɵɵreference(9); return _r0.list(); });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(12);
        ɵɵproperty("profile", ctx.profile);
    } }, directives: [MatCard, MatCardTitle, MatButton, MatIcon, ProfileSelectListComponent, ProfileFormComponent], styles: ["span[my-mat-list-item-span][_ngcontent-%COMP%]{margin-left:auto}.mat-list-item[_ngcontent-%COMP%]:hover{background-color:rgba(187,222,251,.49411764705882355);border-radius:20px}div.ppcc[_ngcontent-%COMP%]{display:inherit;height:100%;overflow:hidden}div.ppcc[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{margin:0 5px}p[matLine][_ngcontent-%COMP%]{margin-bottom:0;white-space:pre-wrap}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ProfilesComponent, [{
        type: Component,
        args: [{
                selector: 'dst-sec-profiles',
                templateUrl: './profiles.component.html',
                styleUrls: ['./profiles.component.css']
            }]
    }], function () { return [{ type: ProfileService }]; }, null); })();

function Login2Component_div_21_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 13);
    ɵɵelementStart(1, "div", 14);
    ɵɵtext(2);
    ɵɵelementStart(3, "a", 15);
    ɵɵtext(4);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵtextInterpolate1("", ctx_r1.resetPasswordText, " ");
    ɵɵadvance(2);
    ɵɵtextInterpolate(ctx_r1.resetLinkText);
} }
class Login2Component {
    constructor(principalService, env, router, userNotify) {
        this.principalService = principalService;
        this.env = env;
        this.router = router;
        this.userNotify = userNotify;
        this.pattern = '.+';
        this.cardTitle = "Login Form";
        this.resetPasswordText = "Hai dimenticato la password? Clicca";
        this.resetLinkText = "qui";
        this.loginSuccessUrl = "/";
        if (env.LOGIN_SUCCESS_URL)
            this.loginSuccessUrl = env.LOGIN_SUCCESS_URL;
        console.debug(this.loginSuccessUrl);
    }
    ngOnInit() {
    }
    login() {
        this.principalService.login(this.username, this.password).subscribe(response => {
            console.debug(this.loginSuccessUrl);
            this.router.navigate([this.loginSuccessUrl]);
        }, error => {
            this.userNotify.notifyWarning("Login error");
        });
    }
}
Login2Component.ɵfac = function Login2Component_Factory(t) { return new (t || Login2Component)(ɵɵdirectiveInject(PrincipalService), ɵɵdirectiveInject('environment'), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(UserNotifyService)); };
Login2Component.ɵcmp = ɵɵdefineComponent({ type: Login2Component, selectors: [["dst-sec-login2"]], inputs: { pattern: "pattern", resetPassword: "resetPassword", cardTitle: "cardTitle", resetPasswordText: "resetPasswordText", resetLinkText: "resetLinkText" }, decls: 27, vars: 6, consts: [["id", "dst-securty-login"], ["id", "dst-securty-login-title"], ["loginForm", "ngForm"], ["id", "dst-securty-login-logo-row", 1, "row"], [1, "col", "login-logo", "text-center"], ["src", "/assets/logo_login.png", "alt", "Responsive image", 1, "img-fluid"], [1, "row"], [1, "col"], ["matInput", "", "type", "email", "placeholder", "Inserisci la tua email", "name", "email", "required", "", 3, "ngModel", "pattern", "ngModelChange"], ["matInput", "", "type", "password", "placeholder", "Inserisci la tua password", "name", "password", "required", "", 3, "ngModel", "ngModelChange"], ["class", "row", "id", "dst-securty-login-reset-row", 4, "ngIf"], ["id", "dst-securty-login-button-row", 1, "row"], ["color", "primary", "mat-button", "", "mat-flat-button", "", 1, "login", 3, "disabled", "click"], ["id", "dst-securty-login-reset-row", 1, "row"], [1, "col-12", "text-align-center"], ["routerLink", "/security/resetPassword"]], template: function Login2Component_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "mat-card", 0);
        ɵɵelementStart(1, "mat-card-title", 1);
        ɵɵtext(2);
        ɵɵelementEnd();
        ɵɵelementStart(3, "mat-card-content");
        ɵɵelementStart(4, "form", null, 2);
        ɵɵelementStart(6, "div", 3);
        ɵɵelementStart(7, "div", 4);
        ɵɵelement(8, "img", 5);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(9, "div", 6);
        ɵɵelementStart(10, "div", 7);
        ɵɵelementStart(11, "mat-form-field");
        ɵɵelementStart(12, "mat-label");
        ɵɵtext(13, "Nome Utente o Email");
        ɵɵelementEnd();
        ɵɵelementStart(14, "input", 8);
        ɵɵlistener("ngModelChange", function Login2Component_Template_input_ngModelChange_14_listener($event) { return ctx.username = $event; });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(15, "div", 6);
        ɵɵelementStart(16, "div", 7);
        ɵɵelementStart(17, "mat-form-field");
        ɵɵelementStart(18, "mat-label");
        ɵɵtext(19, "Password");
        ɵɵelementEnd();
        ɵɵelementStart(20, "input", 9);
        ɵɵlistener("ngModelChange", function Login2Component_Template_input_ngModelChange_20_listener($event) { return ctx.password = $event; });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(21, Login2Component_div_21_Template, 5, 2, "div", 10);
        ɵɵelementStart(22, "div", 11);
        ɵɵelementStart(23, "div", 7);
        ɵɵelementStart(24, "button", 12);
        ɵɵlistener("click", function Login2Component_Template_button_click_24_listener() { return ctx.login(); });
        ɵɵtext(25, "ACCEDI");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(26, "br");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵɵreference(5);
        ɵɵadvance(2);
        ɵɵtextInterpolate(ctx.cardTitle);
        ɵɵadvance(12);
        ɵɵproperty("ngModel", ctx.username)("pattern", ctx.pattern);
        ɵɵadvance(6);
        ɵɵproperty("ngModel", ctx.password);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.resetPassword);
        ɵɵadvance(3);
        ɵɵproperty("disabled", _r0.invalid);
    } }, directives: [MatCard, MatCardTitle, MatCardContent, ɵangular_packages_forms_forms_y, NgControlStatusGroup, NgForm, MatFormField, MatLabel, MatInput, DefaultValueAccessor, RequiredValidator, NgControlStatus, NgModel, PatternValidator, NgIf, MatButton, RouterLinkWithHref], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(Login2Component, [{
        type: Component,
        args: [{
                selector: 'dst-sec-login2',
                templateUrl: './login2.component.html',
                styleUrls: ['./login2.component.css']
            }]
    }], function () { return [{ type: PrincipalService }, { type: undefined, decorators: [{
                type: Inject,
                args: ['environment']
            }] }, { type: Router }, { type: UserNotifyService }]; }, { pattern: [{
            type: Input
        }], resetPassword: [{
            type: Input
        }], cardTitle: [{
            type: Input
        }], resetPasswordText: [{
            type: Input
        }], resetLinkText: [{
            type: Input
        }] }); })();

class SearchPrincipal2Component {
    constructor() { }
    ngOnInit() {
    }
}
SearchPrincipal2Component.ɵfac = function SearchPrincipal2Component_Factory(t) { return new (t || SearchPrincipal2Component)(); };
SearchPrincipal2Component.ɵcmp = ɵɵdefineComponent({ type: SearchPrincipal2Component, selectors: [["dst-sec-search-principal2"]], decls: 2, vars: 0, template: function SearchPrincipal2Component_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "p");
        ɵɵtext(1, " search-principal2 works!\n");
        ɵɵelementEnd();
    } }, styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(SearchPrincipal2Component, [{
        type: Component,
        args: [{
                selector: 'dst-sec-search-principal2',
                templateUrl: './search-principal2.component.html',
                styleUrls: ['./search-principal2.component.css']
            }]
    }], function () { return []; }, null); })();

class PrincipalItemComponent {
    constructor() { }
    ngOnInit() {
    }
}
PrincipalItemComponent.ɵfac = function PrincipalItemComponent_Factory(t) { return new (t || PrincipalItemComponent)(); };
PrincipalItemComponent.ɵcmp = ɵɵdefineComponent({ type: PrincipalItemComponent, selectors: [["dst-sec-principal-item"]], decls: 7, vars: 0, consts: [["mat-card-avatar", "", 1, "example-header-image"]], template: function PrincipalItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "mat-card");
        ɵɵelementStart(1, "mat-card-header");
        ɵɵelement(2, "div", 0);
        ɵɵelementStart(3, "mat-card-title");
        ɵɵtext(4, "Shiba Inu");
        ɵɵelementEnd();
        ɵɵelementStart(5, "mat-card-subtitle");
        ɵɵtext(6, "Dog Breed");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } }, directives: [MatCard, MatCardHeader, MatCardAvatar, MatCardTitle, MatCardSubtitle], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PrincipalItemComponent, [{
        type: Component,
        args: [{
                selector: 'dst-sec-principal-item',
                templateUrl: './principal-item.component.html',
                styleUrls: ['./principal-item.component.css']
            }]
    }], function () { return []; }, null); })();

class DstSecurityModule {
}
DstSecurityModule.ɵmod = ɵɵdefineNgModule({ type: DstSecurityModule });
DstSecurityModule.ɵinj = ɵɵdefineInjector({ factory: function DstSecurityModule_Factory(t) { return new (t || DstSecurityModule)(); }, providers: [PrincipalService, InterceptorService, HandleErrorServiceService, UserNotifyService], imports: [[
            MaterialModule,
            FormsModule,
            ReactiveFormsModule,
            CommonModule,
            RouterModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(DstSecurityModule, { declarations: [DstSecurityComponent,
        LoginComponent,
        SearchPrincipalComponent,
        EditPrincipalComponent,
        ResetPasswordComponent,
        PasswordResetComponent,
        ChangePasswordComponent,
        ProfileComponent,
        SystemsComponent,
        ProfilesComponent,
        SysRolesComponent,
        Login2Component,
        SearchPrincipal2Component,
        PrincipalItemComponent,
        ProfileFormComponent,
        ConfirmDialogComponent, ProfileSelectListComponent], imports: [MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        RouterModule], exports: [DstSecurityComponent,
        LoginComponent,
        Login2Component,
        SearchPrincipalComponent,
        EditPrincipalComponent,
        ResetPasswordComponent,
        PasswordResetComponent,
        SystemsComponent,
        ProfileComponent,
        ProfileFormComponent,
        ChangePasswordComponent,
        ConfirmDialogComponent,
        ProfileSelectListComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(DstSecurityModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DstSecurityComponent,
                    LoginComponent,
                    SearchPrincipalComponent,
                    EditPrincipalComponent,
                    ResetPasswordComponent,
                    PasswordResetComponent,
                    ChangePasswordComponent,
                    ProfileComponent,
                    SystemsComponent,
                    ProfilesComponent,
                    SysRolesComponent,
                    Login2Component,
                    SearchPrincipal2Component,
                    PrincipalItemComponent,
                    ProfileFormComponent,
                    ConfirmDialogComponent, ProfileSelectListComponent
                ],
                imports: [
                    MaterialModule,
                    FormsModule,
                    ReactiveFormsModule,
                    CommonModule,
                    RouterModule
                ],
                exports: [
                    DstSecurityComponent,
                    LoginComponent,
                    Login2Component,
                    SearchPrincipalComponent,
                    EditPrincipalComponent,
                    ResetPasswordComponent,
                    PasswordResetComponent,
                    SystemsComponent,
                    ProfileComponent,
                    ProfileFormComponent,
                    ChangePasswordComponent,
                    ConfirmDialogComponent,
                    ProfileSelectListComponent
                ],
                providers: [PrincipalService, InterceptorService, HandleErrorServiceService, UserNotifyService]
            }]
    }], null, null); })();

/*
 * Public API Surface of dst-security
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ChangePasswordComponent, ConfirmDialogComponent, DstSecurityComponent, DstSecurityModule, DstSecurityService, EditPrincipalComponent, HandleErrorServiceService, InterceptorService, Login2Component, LoginComponent, PasswordResetComponent, PrincipalService, ProfileComponent, ProfileFormComponent, ProfileSelectListComponent, ProfilesComponent, ResetPasswordComponent, SearchPrincipalComponent, SystemService, SystemsComponent, UserNotifyService };
//# sourceMappingURL=dst-security.js.map
